[
  {
    "id": "Schematic_StartingRecipes_C",
    "name": "Starting Blueprints",
    "unlockName": "Starting Blueprints",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_IngotIron_C",
          "Recipe_IronPlate_C",
          "Recipe_IronRod_C",
          "Recipe_TradingPost_C",
          "Recipe_XenoZapper_C",
          "Recipe_WorkBench_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_SaveCompatibility_C",
    "name": "Save Compatibility",
    "unlockName": "Save Compatibility",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Fence_01_C",
          "Recipe_Wall_Window_8x4_03_Steel_C",
          "Recipe_Wall_Conveyor_8x4_04_C",
          "Recipe_Wall_Conveyor_8x4_04_Steel_C",
          "Recipe_JumpPad_C",
          "Recipe_JumpPadTilted_C",
          "Recipe_Walkway_Straight_C",
          "Recipe_Walkway_Cross_C",
          "Recipe_Walkway_T_C",
          "Recipe_Walkway_Ramp_C",
          "Recipe_Walkway_Turn_C",
          "Recipe_PillarTop_C",
          "Recipe_SteelWall_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CustomizerUnlock_ColourSwatches_C",
    "name": "Customizer Color Swatches",
    "unlockName": "Customizer Color Swatches",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Swatch_Slot0_C",
          "Recipe_Swatch_Slot1_C",
          "Recipe_Swatch_Slot2_C",
          "Recipe_Swatch_Slot3_C",
          "Recipe_Swatch_Slot4_C",
          "Recipe_Swatch_Slot5_C",
          "Recipe_Swatch_Slot6_C",
          "Recipe_Swatch_Slot7_C",
          "Recipe_Swatch_Slot8_C",
          "Recipe_Swatch_Slot9_C",
          "Recipe_Swatch_Slot10_C",
          "Recipe_Swatch_Slot11_C",
          "Recipe_Swatch_Slot12_C",
          "Recipe_Swatch_Slot13_C",
          "Recipe_Swatch_Slot14_C",
          "Recipe_Swatch_Slot15_C",
          "Recipe_Swatch_Slot16_C",
          "Recipe_Swatch_Slot18_C",
          "Recipe_Swatch_Slot19_C",
          "Recipe_Swatch_Slot20_C",
          "Recipe_Swatch_Custom_C",
          "Recipe_Swatch_ProjectAssembly_C"
        ]
      }
    ]
  },
  {
    "id": "CustomizerUnlock_PipelineSwatch_C",
    "name": "Pipeline Swatch",
    "unlockName": "Pipeline Swatch",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-1_C",
      "Schematic_2-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Swatch_Slot17_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_2-5_C",
    "name": "Resource Sink Bonus Program",
    "unlockName": "Resource Sink Bonus Program",
    "description": "This Build Gun software upgrade adds a new tab to the Build Menu: The Customizer. From here pioneers have access to the Color section, as well as Material and Pattern options, which can be purchased in the AWESOME Shop.",
    "tier": 2,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Cement_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_IronRod_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ResourceSink_C",
          "Recipe_ResourceSinkShop_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CustomizerUnlock_ColourSwatches_C",
          "CustomizerUnlock_PipelineSwatch_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_3-1_C",
    "name": "Coal Power",
    "unlockName": "Coal Power",
    "description": "",
    "tier": 3,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronPlateReinforced_C",
        "amount": 150,
        "displayAmount": 150,
        "originalAmount": 150
      },
      {
        "resource": "Desc_Rotor_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_GeneratorCoal_C",
          "Recipe_WaterPump_C",
          "Recipe_Pipeline_C",
          "Recipe_PipeSupport_C",
          "Recipe_PipelineJunction_Cross_C",
          "Recipe_PipelinePump_C",
          "Recipe_PipeStorageTank_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CustomizerUnlock_PipelineSwatch_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Quartz_4_1_C",
    "name": "Radio Signal Scanning",
    "unlockName": "Radio Signal Scanning",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CrystalOscillator_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Motor_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "BP_EquipmentDescriptorObjectScanner_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Sulfur_RocketFuel_C",
    "name": "Rocket Fuel",
    "unlockName": "Rocket Fuel",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HardDrive_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_GasTank_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_TurboFuel_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RocketFuel_C",
          "Recipe_PackagedRocketFuel_C",
          "Recipe_UnpackageRocketFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_RocketFuel_Nitro_C",
    "name": "Alternate: Nitro Rocket Fuel",
    "unlockName": "Alternate: Nitro Rocket Fuel",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_RocketFuel_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_RocketFuel_Nitro_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_9-2_C",
    "name": "Quantum Encoding",
    "unlockName": "Quantum Encoding",
    "description": "",
    "tier": 9,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_TimeCrystal_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_FicsiteMesh_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_MotorLightweight_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_ComputerSuper_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuantumEncoder_C",
          "Recipe_QuantumEnergy_C",
          "Recipe_DarkEnergy_C",
          "Recipe_DarkMatter_C",
          "Recipe_SuperpositionOscillator_C",
          "Recipe_TemporalProcessor_C",
          "Recipe_SpaceElevatorPart_12_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_IonizedFuel_C",
    "name": "Ionized Fuel",
    "unlockName": "Ionized Fuel",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HardDrive_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_CrystalShard_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_PackagedRocketFuel_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_IonizedFuel_C",
          "Recipe_PackagedIonizedFuel_C",
          "Recipe_UnpackageIonizedFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_IonizedFuel_Dark_C",
    "name": "Alternate: Dark-Ion Fuel",
    "unlockName": "Alternate: Dark-Ion Fuel",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-2_C",
      "Research_Sulfur_IonizedFuel_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_IonizedFuel_Dark_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_9-1-1_C",
    "name": "Matter Conversion - Background Unlocks",
    "unlockName": "Matter Conversion - Background Unlocks",
    "description": "",
    "tier": 9,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Limestone_Sulfur_C",
          "Recipe_Iron_Limestone_C",
          "Recipe_Coal_Iron_C",
          "Recipe_Coal_Limestone_C",
          "Recipe_Sulfur_Coal_C",
          "Recipe_Sulfur_Iron_C",
          "Recipe_Quartz_Bauxite_C",
          "Recipe_Quartz_Coal_C",
          "Recipe_Copper_Quartz_C",
          "Recipe_Copper_Sulfur_C",
          "Recipe_Caterium_Copper_C",
          "Recipe_Caterium_Quartz_C",
          "Recipe_Bauxite_Caterium_C",
          "Recipe_Bauxite_Copper_C",
          "Recipe_Nitrogen_Bauxite_C",
          "Recipe_Nitrogen_Caterium_C",
          "Recipe_Uranium_Bauxite_C"
        ]
      },
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_FicsiteIngot_AL_C",
          "Recipe_FicsiteIngot_CAT_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_9-1_C",
    "name": "Matter Conversion",
    "unlockName": "Matter Conversion",
    "description": "",
    "tier": 9,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ModularFrameFused_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_ModularFrameLightweight_C",
        "amount": 250,
        "displayAmount": 250,
        "originalAmount": 250
      },
      {
        "resource": "Desc_CoolingSystem_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Converter_C",
          "Recipe_FicsiteIngot_Iron_C",
          "Recipe_FicsiteMesh_C",
          "Recipe_Diamond_C",
          "Recipe_TimeCrystal_C",
          "Recipe_SpaceElevatorPart_10_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_9-1-1_C"
        ]
      },
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_IngotSAM_C",
          "Recipe_SAMFluctuator_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_0_C",
    "name": "Sulfur",
    "unlockName": "Sulfur",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Sulfur_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": []
  },
  {
    "id": "Schematic_Alternate_EnrichedCoal_C",
    "name": "Alternate: Compacted Coal",
    "unlockName": "Alternate: Compacted Coal",
    "description": "",
    "tier": 4,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-1_C",
      "Research_Sulfur_0_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_EnrichedCoal_C",
          "Recipe_Alternate_Coal_1_C",
          "Recipe_Alternate_Coal_2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_5-1-1_C",
    "name": "Oil Processing 2",
    "unlockName": "Oil Processing 2",
    "description": "",
    "tier": 5,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ResidualPlastic_C",
          "Recipe_ResidualRubber_C",
          "Recipe_ResidualFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_5-1_C",
    "name": "Oil Processing",
    "unlockName": "Oil Processing",
    "description": "Awesome new products will become available in the AWESOME Shop upon obtaining this Milestone.",
    "tier": 5,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Motor_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_SteelPlateReinforced_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_CopperSheet_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PetroleumCoke_C",
          "Recipe_CircuitBoard_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_5-1-1_C"
        ]
      },
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_OilPump_C",
          "Recipe_OilRefinery_C",
          "Recipe_Valve_C",
          "Recipe_Plastic_C",
          "Recipe_Rubber_C",
          "Recipe_LiquidFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_TurboFuel_C",
    "name": "Alternate: Turbofuel",
    "unlockName": "Alternate: Turbofuel",
    "description": "",
    "tier": 6,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C",
      "Schematic_Alternate_EnrichedCoal_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Turbofuel_C",
          "Recipe_PackagedTurboFuel_C",
          "Recipe_UnpackageTurboFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_TurboFuel_C",
    "name": "Turbofuel",
    "unlockName": "Turbofuel",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HardDrive_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_CompactedCoal_C",
        "amount": 15,
        "displayAmount": 15,
        "originalAmount": 15
      },
      {
        "resource": "Desc_Fuel_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Turbofuel_C",
          "Recipe_PackagedTurboFuel_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_Alternate_TurboFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Diamond_Turbo_C",
    "name": "Alternate: Turbo Diamonds",
    "unlockName": "Alternate: Turbo Diamonds",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-1_C",
      "Research_Sulfur_TurboFuel_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Diamond_Turbo_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Diamond_Pink_C",
    "name": "Alternate: Pink Diamonds",
    "unlockName": "Alternate: Pink Diamonds",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Diamond_Pink_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Diamond_Petroleum_C",
    "name": "Alternate: Petroleum Diamonds",
    "unlockName": "Alternate: Petroleum Diamonds",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Diamond_Petroleum_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Diamond_OilBased_C",
    "name": "Alternate: Oil-Based Diamonds",
    "unlockName": "Alternate: Oil-Based Diamonds",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Diamond_OilBased_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Diamond_Cloudy_C",
    "name": "Alternate: Cloudy Diamonds",
    "unlockName": "Alternate: Cloudy Diamonds",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Diamond_Cloudy_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_DarkMatter_Trap_C",
    "name": "Alternate: Dark Matter Trap",
    "unlockName": "Alternate: Dark Matter Trap",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_DarkMatter_Trap_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_DarkMatter_Crystallization_C",
    "name": "Alternate: Dark Matter Crystallization",
    "unlockName": "Alternate: Dark Matter Crystallization",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_DarkMatter_Crystallization_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_WetConcrete_C",
    "name": "Alternate: Wet Concrete",
    "unlockName": "Alternate: Wet Concrete",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_WetConcrete_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_TurboHeavyFuel_C",
    "name": "Alternate: Turbo Heavy Fuel",
    "unlockName": "Alternate: Turbo Heavy Fuel",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C",
      "Schematic_Alternate_EnrichedCoal_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_TurboHeavyFuel_C",
          "Recipe_PackagedTurboFuel_C",
          "Recipe_UnpackageTurboFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_3-4_C",
    "name": "Basic Steel Production",
    "unlockName": "Basic Steel Production",
    "description": "Awesome new products will become available in the AWESOME Shop upon obtaining this Milestone.",
    "tier": 3,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Rotor_C",
        "amount": 150,
        "displayAmount": 150,
        "originalAmount": 150
      },
      {
        "resource": "Desc_Cement_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SmelterMk1_C",
          "Recipe_IngotSteel_C",
          "Recipe_SteelBeam_C",
          "Recipe_SteelPipe_C",
          "Recipe_SpaceElevatorPart_2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_SteelRod_C",
    "name": "Alternate: Steel Rod",
    "unlockName": "Alternate: Steel Rod",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_SteelRod_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_5-4-1_C",
    "name": "Alternative Fluid Transport 2",
    "unlockName": "Alternative Fluid Transport 2",
    "description": "",
    "tier": 5,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_UnpackageWater_C",
          "Recipe_UnpackageOil_C",
          "Recipe_UnpackageFuel_C",
          "Recipe_UnpackageOilResidue_C",
          "Recipe_UnpackageBioFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_5-4_C",
    "name": "Fluid Packaging",
    "unlockName": "Fluid Packaging",
    "description": "",
    "tier": 5,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Plastic_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_SteelPlate_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      },
      {
        "resource": "Desc_CopperSheet_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Packager_C",
          "Recipe_FluidCanister_C",
          "Recipe_PackagedWater_C",
          "Recipe_PackagedCrudeOil_C",
          "Recipe_Fuel_C",
          "Recipe_PackagedOilResidue_C",
          "Recipe_PackagedBiofuel_C",
          "Recipe_LiquidBiofuel_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_5-4-1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_SteelCanister_C",
    "name": "Alternate: Steel Canister",
    "unlockName": "Alternate: Steel Canister",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_SteelCanister_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_SteamedCopperSheet_C",
    "name": "Alternate: Steamed Copper Sheet",
    "unlockName": "Alternate: Steamed Copper Sheet",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_SteamedCopperSheet_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_RubberConcrete_C",
    "name": "Alternate: Rubber Concrete",
    "unlockName": "Alternate: Rubber Concrete",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_RubberConcrete_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_RecycledRubber_C",
    "name": "Alternate: Recycled Rubber",
    "unlockName": "Alternate: Recycled Rubber",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_RecycledRubber_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Quartz_1_1_C",
    "name": "Quartz Crystals",
    "unlockName": "Quartz Crystals",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_RawQuartz_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuartzCrystal_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_PureQuartzCrystal_C",
    "name": "Alternate: Pure Quartz Crystal",
    "unlockName": "Alternate: Pure Quartz Crystal",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_1_1_C",
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_PureQuartzCrystal_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_PureIronIngot_C",
    "name": "Alternate: Pure Iron Ingot",
    "unlockName": "Alternate: Pure Iron Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_PureIronIngot_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_PureCopperIngot_C",
    "name": "Alternate: Pure Copper Ingot",
    "unlockName": "Alternate: Pure Copper Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_PureCopperIngot_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_0_C",
    "name": "Caterium",
    "unlockName": "Caterium",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_OreGold_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": []
  },
  {
    "id": "Schematic_Alternate_PureCateriumIngot_C",
    "name": "Alternate: Pure Caterium Ingot",
    "unlockName": "Alternate: Pure Caterium Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_0_C",
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_PureCateriumIngot_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_7-1-1_C",
    "name": "Bauxite Refinement 2",
    "unlockName": "Bauxite Refinement 2",
    "description": "",
    "tier": 7,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_UnpackageAlumina_C",
          "Recipe_QuartzCrystal_C",
          "Recipe_CrystalOscillator_C",
          "Recipe_Silica_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_7-1_C",
    "name": "Bauxite Refinement",
    "unlockName": "Bauxite Refinement",
    "description": "",
    "tier": 7,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Computer_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_ModularFrameHeavy_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Motor_C",
        "amount": 250,
        "displayAmount": 250,
        "originalAmount": 250
      },
      {
        "resource": "Desc_Rubber_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_AluminaSolution_C",
          "Recipe_PackagedAlumina_C",
          "Recipe_AluminumScrap_C",
          "Recipe_IngotAluminum_C",
          "Recipe_AluminumSheet_C",
          "Recipe_AluminumCasing_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_7-1-1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_PureAluminumIngot_C",
    "name": "Alternate: Pure Aluminum Ingot",
    "unlockName": "Alternate: Pure Aluminum Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PureAluminumIngot_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_PolymerResin_C",
    "name": "Alternate: Polymer Resin",
    "unlockName": "Alternate: Polymer Resin",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_PolymerResin_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_PlasticSmartPlating_C",
    "name": "Alternate: Plastic Smart Plating",
    "unlockName": "Alternate: Plastic Smart Plating",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_PlasticSmartPlating_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_4-1_C",
    "name": "Advanced Steel Production",
    "unlockName": "Advanced Steel Production",
    "description": "",
    "tier": 4,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Rotor_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_Cement_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_MinerMk2_C",
          "Recipe_EncasedIndustrialBeam_C",
          "Recipe_Stator_C",
          "Recipe_Motor_C",
          "Recipe_SpaceElevatorPart_3_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_4_1_C",
    "name": "AI Limiter",
    "unlockName": "AI Limiter",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HighSpeedWire_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_CopperSheet_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_AILimiter_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_HighSpeedWiring_C",
    "name": "Alternate: Automated Speed Wiring",
    "unlockName": "Alternate: Automated Speed Wiring",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_4-1_C",
      "Research_Caterium_4_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_HighSpeedWiring_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_HeavyOilResidue_C",
    "name": "Alternate: Heavy Oil Residue",
    "unlockName": "Alternate: Heavy Oil Residue",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_HeavyOilResidue_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_5-2_C",
    "name": "Industrial Manufacturing",
    "unlockName": "Industrial Manufacturing",
    "description": "",
    "tier": 6,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Motor_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_Plastic_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ManufacturerMk1_C",
          "Recipe_Computer_C",
          "Recipe_ModularFrameHeavy_C",
          "Recipe_SpaceElevatorPart_4_C",
          "Recipe_SpaceElevatorPart_5_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_HeavyFlexibleFrame_C",
    "name": "Alternate: Heavy Flexible Frame",
    "unlockName": "Alternate: Heavy Flexible Frame",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_HeavyFlexibleFrame_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_FusedWire_C",
    "name": "Alternate: Fused Wire",
    "unlockName": "Alternate: Fused Wire",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_0_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_FusedWire_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_FlexibleFramework_C",
    "name": "Alternate: Flexible Framework",
    "unlockName": "Alternate: Flexible Framework",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_FlexibleFramework_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_ElectrodeCircuitBoard_C",
    "name": "Alternate: Electrode Circuit Board",
    "unlockName": "Alternate: Electrode Circuit Board",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_ElectrodeCircuitBoard_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_ElectroAluminumScrap_C",
    "name": "Alternate: Electrode Aluminum Scrap",
    "unlockName": "Alternate: Electrode Aluminum Scrap",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_ElectroAluminumScrap_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_DilutedPackagedFuel_C",
    "name": "Alternate: Diluted Packaged Fuel",
    "unlockName": "Alternate: Diluted Packaged Fuel",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_DilutedPackagedFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_2-1_C",
    "name": "Part Assembly",
    "unlockName": "Part Assembly",
    "description": "",
    "tier": 2,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Cable_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_IronRod_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_IronScrew_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 300,
        "displayAmount": 300,
        "originalAmount": 300
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_AssemblerMk1_C",
          "Recipe_CopperSheet_C",
          "Recipe_Rotor_C",
          "Recipe_ModularFrame_C",
          "Recipe_SpaceElevatorPart_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CopperRotor_C",
    "name": "Alternate: Copper Rotor",
    "unlockName": "Alternate: Copper Rotor",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_2-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CopperRotor_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CopperAlloyIngot_C",
    "name": "Alternate: Copper Alloy Ingot",
    "unlockName": "Alternate: Copper Alloy Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CopperAlloyIngot_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CokeSteelIngot_C",
    "name": "Alternate: Coke Steel Ingot",
    "unlockName": "Alternate: Coke Steel Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CokeSteelIngot_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CoatedIronPlate_C",
    "name": "Alternate: Coated Iron Plate",
    "unlockName": "Alternate: Coated Iron Plate",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CoatedIronPlate_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CoatedIronCanister_C",
    "name": "Alternate: Coated Iron Canister",
    "unlockName": "Alternate: Coated Iron Canister",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CoatedIronCanister_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CoatedCable_C",
    "name": "Alternate: Coated Cable",
    "unlockName": "Alternate: Coated Cable",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CoatedCable_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_BoltedFrame_C",
    "name": "Alternate: Bolted Frame",
    "unlockName": "Alternate: Bolted Frame",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_2-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_BoltedFrame_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_AdheredIronPlate_C",
    "name": "Alternate: Adhered Iron Plate",
    "unlockName": "Alternate: Adhered Iron Plate",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_AdheredIronPlate_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_8-5-1_C",
    "name": "Particle Enrichment 2",
    "unlockName": "Particle Enrichment 2",
    "description": "",
    "tier": 8,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_UnpackageNitricAcid_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_8-5_C",
    "name": "Particle Enrichment",
    "unlockName": "Particle Enrichment",
    "description": "",
    "tier": 8,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_MotorLightweight_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_ModularFrameFused_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_CoolingSystem_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_HighSpeedWire_C",
        "amount": 2500,
        "displayAmount": 2500,
        "originalAmount": 2500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_NitricAcid_C",
          "Recipe_PackagedNitricAcid_C",
          "Recipe_NonFissileUranium_C",
          "Recipe_Plutonium_C",
          "Recipe_PlutoniumCell_C",
          "Recipe_PlutoniumFuelRod_C",
          "Recipe_HadronCollider_C",
          "Recipe_CopperDust_C",
          "Recipe_PressureConversionCube_C",
          "Recipe_SpaceElevatorPart_9_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_8-5-1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_TurboPressureMotor_C",
    "name": "Alternate: Turbo Pressure Motor",
    "unlockName": "Alternate: Turbo Pressure Motor",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_TurboPressureMotor_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_7-4-1_C",
    "name": "Control System Development 2",
    "unlockName": "Control System Development 2",
    "description": "",
    "tier": 7,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_UnpackageSulfuricAcid_C",
          "Recipe_AILimiter_C",
          "Recipe_HighSpeedConnector_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_7-5_C",
    "name": "Control System Development",
    "unlockName": "Control System Development",
    "description": "",
    "tier": 7,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_AluminumPlate_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_AluminumCasing_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      },
      {
        "resource": "Desc_Computer_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_Plastic_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SulfuricAcid_C",
          "Recipe_PackagedSulfuricAcid_C",
          "Recipe_Battery_C",
          "Recipe_RadioControlUnit_C",
          "Recipe_ComputerSuper_C",
          "Recipe_SpaceElevatorPart_7_C",
          "Recipe_Blender_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_7-4-1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_TurboBlendFuel_C",
    "name": "Alternate: Turbo Blend Fuel",
    "unlockName": "Alternate: Turbo Blend Fuel",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_TurboBlendFuel_C",
          "Recipe_PackagedTurboFuel_C",
          "Recipe_UnpackageTurboFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_8-1_C",
    "name": "Nuclear Power",
    "unlockName": "Nuclear Power",
    "description": "",
    "tier": 8,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ComputerSuper_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_ModularFrameHeavy_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      },
      {
        "resource": "Desc_Cement_C",
        "amount": 2000,
        "displayAmount": 2000,
        "originalAmount": 2000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_UraniumCell_C",
          "Recipe_ElectromagneticControlRod_C",
          "Recipe_NuclearFuelRod_C",
          "Recipe_GeneratorNuclear_C",
          "Recipe_SpaceElevatorPart_6_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_SuperStateComputer_C",
    "name": "Alternate: Super-State Computer",
    "unlockName": "Alternate: Super-State Computer",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-1_C",
      "Schematic_7-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_SuperStateComputer_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_SloppyAlumina_C",
    "name": "Alternate: Sloppy Alumina",
    "unlockName": "Alternate: Sloppy Alumina",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_SloppyAlumina_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_RadioControlSystem_C",
    "name": "Alternate: Radio Control System",
    "unlockName": "Alternate: Radio Control System",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_RadioControlSystem_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_PlutoniumFuelUnit_C",
    "name": "Alternate: Plutonium Fuel Unit",
    "unlockName": "Alternate: Plutonium Fuel Unit",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_PlutoniumFuelUnit_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_8-2-1_C",
    "name": "Advanced Aluminum Production 2",
    "unlockName": "Advanced Aluminum Production 2",
    "description": "",
    "tier": 8,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_UnpackageNitrogen_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_8-2_C",
    "name": "Advanced Aluminum Production",
    "unlockName": "Advanced Aluminum Production",
    "description": "",
    "tier": 8,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ModularFrameLightweight_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_AluminumCasing_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_AluminumPlate_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 3000,
        "displayAmount": 3000,
        "originalAmount": 3000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_FrackingSmasher_C",
          "Recipe_FrackingExtractor_C"
        ]
      },
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_GasTank_C",
          "Recipe_PackagedNitrogen_C",
          "Recipe_HeatSink_C",
          "Recipe_CoolingSystem_C",
          "Recipe_FusedModularFrame_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_8-2-1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_OCSupercomputer_C",
    "name": "Alternate: OC Supercomputer",
    "unlockName": "Alternate: OC Supercomputer",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-5_C",
      "Schematic_8-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_OCSupercomputer_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_InstantScrap_C",
    "name": "Alternate: Instant Scrap",
    "unlockName": "Alternate: Instant Scrap",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-1_C",
      "Schematic_7-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_InstantScrap_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_InstantPlutoniumCell_C",
    "name": "Alternate: Instant Plutonium Cell",
    "unlockName": "Alternate: Instant Plutonium Cell",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_InstantPlutoniumCell_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_HeatFusedFrame_C",
    "name": "Alternate: Heat-Fused Frame",
    "unlockName": "Alternate: Heat-Fused Frame",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_HeatFusedFrame_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_FertileUranium_C",
    "name": "Alternate: Fertile Uranium",
    "unlockName": "Alternate: Fertile Uranium",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_FertileUranium_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_ElectricMotor_C",
    "name": "Alternate: Electric Motor",
    "unlockName": "Alternate: Electric Motor",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_ElectricMotor_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_DilutedFuel_C",
    "name": "Alternate: Diluted Fuel",
    "unlockName": "Alternate: Diluted Fuel",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_DilutedFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CoolingDevice_C",
    "name": "Alternate: Cooling Device",
    "unlockName": "Alternate: Cooling Device",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CoolingDevice_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_ClassicBattery_C",
    "name": "Alternate: Classic Battery",
    "unlockName": "Alternate: Classic Battery",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_ClassicBattery_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_AutomatedMiner_C",
    "name": "Alternate: Automated Miner",
    "unlockName": "Alternate: Automated Miner",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_AutomatedMiner_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_AlcladCasing_C",
    "name": "Alternate: Alclad Casing",
    "unlockName": "Alternate: Alclad Casing",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_AlcladCasing_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_SteelPipe_Molded_C",
    "name": "Alternate: Molded Steel Pipe",
    "unlockName": "Alternate: Molded Steel Pipe",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_SteelPipe_Molded_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_SteelPipe_Iron_C",
    "name": "Alternate: Iron Pipe",
    "unlockName": "Alternate: Iron Pipe",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_SteelPipe_Iron_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_SteelCastedPlate_C",
    "name": "Alternate: Steel Cast Plate",
    "unlockName": "Alternate: Steel Cast Plate",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_SteelCastedPlate_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_SteelBeam_Molded_C",
    "name": "Alternate: Molded Beam",
    "unlockName": "Alternate: Molded Beam",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_SteelBeam_Molded_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_SteelBeam_Aluminum_C",
    "name": "Alternate: Aluminum Beam",
    "unlockName": "Alternate: Aluminum Beam",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_SteelBeam_Aluminum_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_AluminumRod_C",
    "name": "Alternate: Aluminum Rod",
    "unlockName": "Alternate: Aluminum Rod",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_AluminumRod_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_AILimiter_Plastic_C",
    "name": "Alternate: Plastic AI Limiter",
    "unlockName": "Alternate: Plastic AI Limiter",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_4_1_C",
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_AILimiter_Plastic_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Silica_Distilled_C",
    "name": "Alternate: Distilled Silica",
    "unlockName": "Alternate: Distilled Silica",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Silica_Distilled_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Quartz_Purified_C",
    "name": "Alternate: Quartz Purification",
    "unlockName": "Alternate: Quartz Purification",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Quartz_Purified_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_Alternate_Silica_Distilled_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Quartz_Fused_C",
    "name": "Alternate: Fused Quartz Crystal",
    "unlockName": "Alternate: Fused Quartz Crystal",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_1_1_C",
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Quartz_Fused_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_IronIngot_Leached_C",
    "name": "Alternate: Leached Iron Ingot",
    "unlockName": "Alternate: Leached Iron Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_IronIngot_Leached_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_IronIngot_Basic_C",
    "name": "Alternate: Basic Iron Ingot",
    "unlockName": "Alternate: Basic Iron Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_IronIngot_Basic_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CopperIngot_Tempered_C",
    "name": "Alternate: Tempered Copper Ingot",
    "unlockName": "Alternate: Tempered Copper Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CopperIngot_Tempered_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CopperIngot_Leached_C",
    "name": "Alternate: Leached Copper Ingot",
    "unlockName": "Alternate: Leached Copper Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CopperIngot_Leached_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CateriumIngot_Tempered_C",
    "name": "Alternate: Tempered Caterium Ingot",
    "unlockName": "Alternate: Tempered Caterium Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CateriumIngot_Tempered_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CateriumIngot_Leached_C",
    "name": "Alternate: Leached Caterium Ingot",
    "unlockName": "Alternate: Leached Caterium Ingot",
    "description": "",
    "tier": null,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CateriumIngot_Leached_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Wire2_C",
    "name": "Alternate: Caterium Wire",
    "unlockName": "Alternate: Caterium Wire",
    "description": "",
    "tier": 3,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_0_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Wire_2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Wire1_C",
    "name": "Alternate: Iron Wire",
    "unlockName": "Alternate: Iron Wire",
    "description": "",
    "tier": 1,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Wire_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_7-4_C",
    "name": "Aeronautical Engineering",
    "unlockName": "Aeronautical Engineering",
    "description": "",
    "tier": 8,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ModularFrameLightweight_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_AluminumPlate_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_AluminumCasing_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_Motor_C",
        "amount": 300,
        "displayAmount": 300,
        "originalAmount": 300
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_DroneTransport_C",
          "Recipe_DroneStation_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_1_C",
    "name": "Caterium Ingots",
    "unlockName": "Caterium Ingots",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_OreGold_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_IngotCaterium_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Quartz_0_C",
    "name": "Quartz",
    "unlockName": "Quartz",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_RawQuartz_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": []
  },
  {
    "id": "Schematic_Alternate_UraniumCell1_C",
    "name": "Alternate: Infused Uranium Cell",
    "unlockName": "Alternate: Infused Uranium Cell",
    "description": "",
    "tier": 7,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-1_C",
      "Research_Caterium_1_C",
      "Research_Quartz_0_C",
      "Research_Sulfur_0_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_UraniumCell_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_7-2_C",
    "name": "Logistics Mk.5",
    "unlockName": "Logistics Mk.5",
    "description": "",
    "tier": 7,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_AluminumPlate_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_SteelPlateReinforced_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      },
      {
        "resource": "Desc_IronPlateReinforced_C",
        "amount": 600,
        "displayAmount": 600,
        "originalAmount": 600
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorBeltMk5_C",
          "Recipe_ConveyorLiftMk5_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_8-4_C",
    "name": "Leading-Edge Production",
    "unlockName": "Leading-Edge Production",
    "description": "",
    "tier": 8,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ModularFrameFused_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_ComputerSuper_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_MotorTurbo_C",
          "Recipe_MinerMk3_C",
          "Recipe_SpaceElevatorPart_8_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_3_C",
    "name": "Caterium Electronics",
    "unlockName": "Caterium Electronics",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HighSpeedWire_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": []
  },
  {
    "id": "Schematic_Alternate_TurboMotor1_C",
    "name": "Alternate: Turbo Electric Motor",
    "unlockName": "Alternate: Turbo Electric Motor",
    "description": "",
    "tier": 7,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-4_C",
      "Schematic_8-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_TurboMotor_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Stator_C",
    "name": "Alternate: Quickwire Stator",
    "unlockName": "Alternate: Quickwire Stator",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_4-1_C",
      "Research_Caterium_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Stator_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Quartz_1_2_C",
    "name": "Silica",
    "unlockName": "Silica",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_RawQuartz_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Silica_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Silica_C",
    "name": "Alternate: Cheap Silica",
    "unlockName": "Alternate: Cheap Silica",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_1_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Silica_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Screw2_C",
    "name": "Alternate: Steel Screws",
    "unlockName": "Alternate: Steel Screws",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Screw_2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Screw_C",
    "name": "Alternate: Cast Screws",
    "unlockName": "Alternate: Cast Screws",
    "description": "",
    "tier": 1,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Screw_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Rotor_C",
    "name": "Alternate: Steel Rotor",
    "unlockName": "Alternate: Steel Rotor",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Rotor_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_ReinforcedSteelPlate_C",
    "name": "Alternate: Encased Industrial Pipe",
    "unlockName": "Alternate: Encased Industrial Pipe",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_4-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_EncasedIndustrialBeam_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_ReinforcedIronPlate2_C",
    "name": "Alternate: Stitched Iron Plate",
    "unlockName": "Alternate: Stitched Iron Plate",
    "description": "",
    "tier": 2,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_2-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_ReinforcedIronPlate_2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_ReinforcedIronPlate1_C",
    "name": "Alternate: Bolted Iron Plate",
    "unlockName": "Alternate: Bolted Iron Plate",
    "description": "",
    "tier": 2,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_2-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_ReinforcedIronPlate_1_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_5_C",
    "name": "High-Speed Connector",
    "unlockName": "High-Speed Connector",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HighSpeedWire_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_Plastic_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_HighSpeedConnector_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Quartz_3_3_C",
    "name": "Discontinued - Radio Control Unit",
    "unlockName": "Discontinued - Radio Control Unit",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CrystalOscillator_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_AluminumPlate_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RadioControlUnit_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_RadioControlUnit1_C",
    "name": "Alternate: Radio Connection Unit",
    "unlockName": "Alternate: Radio Connection Unit",
    "description": "",
    "tier": 7,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-2_C",
      "Research_Caterium_4_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_RadioControlUnit_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Quickwire_C",
    "name": "Alternate: Fused Quickwire",
    "unlockName": "Alternate: Fused Quickwire",
    "description": "",
    "tier": 3,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Quickwire_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Plastic1_C",
    "name": "Alternate: Recycled Plastic",
    "unlockName": "Alternate: Recycled Plastic",
    "description": "",
    "tier": 5,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Plastic_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_NuclearFuelRod1_C",
    "name": "Alternate: Uranium Fuel Unit",
    "unlockName": "Alternate: Uranium Fuel Unit",
    "description": "",
    "tier": 7,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-1_C",
      "Research_Quartz_1_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_NuclearFuelRod_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Motor1_C",
    "name": "Alternate: Rigor Motor",
    "unlockName": "Alternate: Rigor Motor",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_4-1_C",
      "Research_Quartz_1_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Motor_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_ModularFrame_C",
    "name": "Alternate: Steeled Frame",
    "unlockName": "Alternate: Steeled Frame",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_ModularFrame_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_IngotSteel2_C",
    "name": "Alternate: Compacted Steel Ingot",
    "unlockName": "Alternate: Compacted Steel Ingot",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_Alternate_EnrichedCoal_C",
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_IngotSteel_2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_IngotSteel1_C",
    "name": "Alternate: Solid Steel Ingot",
    "unlockName": "Alternate: Solid Steel Ingot",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_IngotSteel_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_IngotIron_C",
    "name": "Alternate: Iron Alloy Ingot",
    "unlockName": "Alternate: Iron Alloy Ingot",
    "description": "",
    "tier": 1,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_IngotIron_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_HighSpeedConnector_C",
    "name": "Alternate: Silicon High-Speed Connector",
    "unlockName": "Alternate: Silicon High-Speed Connector",
    "description": "",
    "tier": 5,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_5_C",
      "Schematic_5-1_C",
      "Research_Quartz_0_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_HighSpeedConnector_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_HeavyModularFrame_C",
    "name": "Alternate: Heavy Encased Frame",
    "unlockName": "Alternate: Heavy Encased Frame",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_ModularFrameHeavy_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_HeatSink1_C",
    "name": "Alternate: Heat Exchanger",
    "unlockName": "Alternate: Heat Exchanger",
    "description": "",
    "tier": 7,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_HeatSink_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Gunpowder1_C",
    "name": "Alternate: Fine Black Powder",
    "unlockName": "Alternate: Fine Black Powder",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_Alternate_EnrichedCoal_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Gunpowder_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_ElectromagneticControlRod1_C",
    "name": "Alternate: Electromagnetic Connection Rod",
    "unlockName": "Alternate: Electromagnetic Connection Rod",
    "description": "",
    "tier": 7,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-1_C",
      "Research_Caterium_4_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_ElectromagneticControlRod_1_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Quartz_2_C",
    "name": "Crystal Oscillator",
    "unlockName": "Crystal Oscillator",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_QuartzCrystal_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_IronPlateReinforced_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_CrystalOscillator_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CrystalOscillator_C",
    "name": "Alternate: Insulated Crystal Oscillator",
    "unlockName": "Alternate: Insulated Crystal Oscillator",
    "description": "",
    "tier": 5,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_2_C",
      "Research_Caterium_3_C",
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CrystalOscillator_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Concrete_C",
    "name": "Alternate: Fine Concrete",
    "unlockName": "Alternate: Fine Concrete",
    "description": "",
    "tier": 4,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_0_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Concrete_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Computer2_C",
    "name": "Alternate: Crystal Computer",
    "unlockName": "Alternate: Crystal Computer",
    "description": "",
    "tier": 5,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-2_C",
      "Research_Quartz_1_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Computer_2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Computer1_C",
    "name": "Alternate: Caterium Computer",
    "unlockName": "Alternate: Caterium Computer",
    "description": "",
    "tier": 5,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-2_C",
      "Research_Caterium_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Computer_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Coal2_C",
    "name": "Alternate: Biocoal",
    "unlockName": "Alternate: Biocoal",
    "description": "",
    "tier": 3,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Coal_2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Coal1_C",
    "name": "Alternate: Charcoal",
    "unlockName": "Alternate: Charcoal",
    "description": "",
    "tier": 3,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Coal_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CircuitBoard2_C",
    "name": "Alternate: Caterium Circuit Board",
    "unlockName": "Alternate: Caterium Circuit Board",
    "description": "",
    "tier": 5,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C",
      "Research_Caterium_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CircuitBoard_2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_CircuitBoard1_C",
    "name": "Alternate: Silicon Circuit Board",
    "unlockName": "Alternate: Silicon Circuit Board",
    "description": "",
    "tier": 5,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C",
      "Research_Quartz_0_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_CircuitBoard_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Cable2_C",
    "name": "Alternate: Quickwire Cable",
    "unlockName": "Alternate: Quickwire Cable",
    "description": "",
    "tier": 5,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C",
      "Research_Caterium_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Cable_2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_Cable1_C",
    "name": "Alternate: Insulated Cable",
    "unlockName": "Alternate: Insulated Cable",
    "description": "",
    "tier": 5,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_Cable_1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Alternate_InventorySlots2_C",
    "name": "Inflated Pocket Dimension",
    "unlockName": "Inflated Pocket Dimension",
    "description": "",
    "tier": 5,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Alternate_InventorySlots1_C",
    "name": "Inflated Pocket Dimension",
    "unlockName": "Inflated Pocket Dimension",
    "description": "",
    "tier": 2,
    "type": "Alternate",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Skin_Buildgun_Striped_C",
    "name": "Striped Build Gun",
    "unlockName": "Striped Build Gun",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Skin_Buildgun_Neon_C",
    "name": "Neon Build Gun",
    "unlockName": "Neon Build Gun",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Skin_Buildgun_HalfNHalf_C",
    "name": "FICSIT Half 'n' Half Build Gun",
    "unlockName": "FICSIT Half 'n' Half Build Gun",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Skin_Buildgun_Golden_C",
    "name": "Golden Build Gun",
    "unlockName": "Golden Build Gun",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Skin_Buildgun_Default_C",
    "name": "Standard FICSIT Build Gun",
    "unlockName": "Standard FICSIT Build Gun",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Skin_Buildgun_ColoredSides_C",
    "name": "Alternative FICSIT Build Gun",
    "unlockName": "Alternative FICSIT Build Gun",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Skin_Buildgun_Camo_C",
    "name": "Camo Build Gun",
    "unlockName": "Camo Build Gun",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Helmet_Welder_C",
    "name": "Welder Helmet",
    "unlockName": "Welder Helmet",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Helmet_Scout_C",
    "name": "Scout Helmet",
    "unlockName": "Scout Helmet",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Helmet_Scarf_C",
    "name": "Neko Helmet",
    "unlockName": "Neko Helmet",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Helmet_Neon_C",
    "name": "Neon Helmet",
    "unlockName": "Neon Helmet",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Helmet_Neko_C",
    "name": "Neko Helmet",
    "unlockName": "Neko Helmet",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Helmet_Golden_C",
    "name": "Golden Helmet",
    "unlockName": "Golden Helmet",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Helmet_Ficsmas_C",
    "name": "FICSMAS Hat",
    "unlockName": "FICSMAS Hat",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Helmet_Default_C",
    "name": "Standard FICSIT Helmet",
    "unlockName": "Standard FICSIT Helmet",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Helmet_Bobble_C",
    "name": "Bobblehead Helmet",
    "unlockName": "Bobblehead Helmet",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Helmet_Beta_C",
    "name": "B-374 Helmet",
    "unlockName": "B-374 Helmet",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Trinket_Somersloop_C",
    "name": "Somersloop Trinket",
    "unlockName": "Somersloop Trinket",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Trinket_Nut_C",
    "name": "Golden Nut Trinket",
    "unlockName": "Golden Nut Trinket",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Trinket_NuclearWaste_C",
    "name": "Nuclear Waste Trinket",
    "unlockName": "Nuclear Waste Trinket",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Trinket_FicsmasStar_C",
    "name": "Wonder Star Trinket",
    "unlockName": "Wonder Star Trinket",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Trinket_FicsmasBall_C",
    "name": "Red Ornament Trinket",
    "unlockName": "Red Ornament Trinket",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Trinket_FicsitCoupon_C",
    "name": "Coupon Trinket",
    "unlockName": "Coupon Trinket",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Trinket_Default_C",
    "name": "Wrench Trinket",
    "unlockName": "Wrench Trinket",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Trinket_Checkit_C",
    "name": "Checkit Trinket",
    "unlockName": "Checkit Trinket",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Trinket_Alpaca_C",
    "name": "Alpaca Trinket",
    "unlockName": "Alpaca Trinket",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Trinket_AirFreshener_C",
    "name": "Fresh Factory Trinket",
    "unlockName": "Fresh Factory Trinket",
    "description": "",
    "tier": null,
    "type": "Customization",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_9-5_C",
    "name": "Peak Efficiency",
    "unlockName": "Peak Efficiency",
    "description": "",
    "tier": 9,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_TimeCrystal_C",
        "amount": 250,
        "displayAmount": 250,
        "originalAmount": 250
      },
      {
        "resource": "Desc_FicsiteMesh_C",
        "amount": 250,
        "displayAmount": 250,
        "originalAmount": 250
      },
      {
        "resource": "Desc_AluminumPlate_C",
        "amount": 5000,
        "displayAmount": 5000,
        "originalAmount": 5000
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 10000,
        "displayAmount": 10000,
        "originalAmount": 10000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorBeltMk6_C",
          "Recipe_ConveyorLiftMk6_C",
          "Recipe_Ficsonium_C",
          "Recipe_FicsoniumFuelRod_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_9-4_C",
    "name": "Spatial Energy Regulation",
    "unlockName": "Spatial Energy Regulation",
    "description": "",
    "tier": 9,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_QuantumOscillator_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_MotorLightweight_C",
        "amount": 250,
        "displayAmount": 250,
        "originalAmount": 250
      },
      {
        "resource": "Desc_ModularFrameLightweight_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Portal_C",
          "Recipe_PortalSatellite_C",
          "Recipe_SingularityCell_C",
          "Recipe_SpaceElevatorPart_11_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_9-3_C",
    "name": "FICSIT Blueprints Mk.3",
    "unlockName": "FICSIT Blueprints Mk.3",
    "description": "",
    "tier": 9,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_TemporalProcessor_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_TimeCrystal_C",
        "amount": 250,
        "displayAmount": 250,
        "originalAmount": 250
      },
      {
        "resource": "Desc_FicsiteMesh_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_ModularFrameFused_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_BlueprintDesigner_Mk3_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_8-3_C",
    "name": "Hoverpack",
    "unlockName": "Hoverpack",
    "description": "",
    "tier": 7,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_AluminumPlate_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_ModularFrameHeavy_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Computer_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Motor_C",
        "amount": 250,
        "displayAmount": 250,
        "originalAmount": 250
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Hoverpack_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_7-3_C",
    "name": "Hazmat Suit",
    "unlockName": "Hazmat Suit",
    "description": "",
    "tier": 7,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Filter_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_AluminumCasing_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_HighSpeedWire_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_HazmatSuit_C",
          "Recipe_FilterHazmat_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_6-7_C",
    "name": "Railway Signalling",
    "unlockName": "Railway Signalling",
    "description": "",
    "tier": 6,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Computer_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      },
      {
        "resource": "Desc_CopperSheet_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RailroadBlockSignal_C",
          "Recipe_RailroadPathSignal_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_6-6_C",
    "name": "FICSIT Blueprints Mk.2",
    "unlockName": "FICSIT Blueprints Mk.2",
    "description": "",
    "tier": 6,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ModularFrameHeavy_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Computer_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Rubber_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      },
      {
        "resource": "Desc_Cement_C",
        "amount": 1500,
        "displayAmount": 1500,
        "originalAmount": 1500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_BlueprintDesigner_Mk2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_6-5_C",
    "name": "Pipeline Engineering Mk.2",
    "unlockName": "Pipeline Engineering Mk.2",
    "description": "",
    "tier": 6,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ModularFrameHeavy_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Plastic_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      },
      {
        "resource": "Desc_Rubber_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PipelineMK2_C",
          "Recipe_PipelinePumpMK2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_6-3_C",
    "name": "Monorail Train Technology",
    "unlockName": "Monorail Train Technology",
    "description": "",
    "tier": 6,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Motor_C",
        "amount": 250,
        "displayAmount": 250,
        "originalAmount": 250
      },
      {
        "resource": "Desc_SteelPlateReinforced_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_SteelPlate_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Locomotive_C",
          "Recipe_FreightWagon_C",
          "Recipe_RailroadTrack_C",
          "Recipe_TrainStation_C",
          "Recipe_TrainDockingStation_C",
          "Recipe_TrainDockingStationLiquid_C",
          "Recipe_TrainPlatformEmpty_C",
          "Recipe_TrainPlatformEmpty_02_C",
          "Recipe_RailroadEndStop_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_6-2_C",
    "name": "Jetpack",
    "unlockName": "Jetpack",
    "description": "",
    "tier": 5,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Motor_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_JetPack_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_6-1_C",
    "name": "Logistics Mk.4",
    "unlockName": "Logistics Mk.4",
    "description": "",
    "tier": 5,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Rubber_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_SteelPlateReinforced_C",
        "amount": 300,
        "displayAmount": 300,
        "originalAmount": 300
      },
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorBeltMk4_C",
          "Recipe_ConveyorLiftMk4_C",
          "Recipe_Truck_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_5-5-1_C",
    "name": "Petroleum Power 2",
    "unlockName": "Petroleum Power 2",
    "description": "",
    "tier": 5,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_IngotCaterium_C",
          "Recipe_Quickwire_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_5-5_C",
    "name": "Petroleum Power",
    "unlockName": "Petroleum Power",
    "description": "",
    "tier": 5,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Motor_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_SteelPlateReinforced_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Rubber_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_Plastic_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_GeneratorFuel_C",
          "Recipe_IndustrialTank_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_5-5-1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_5-3_C",
    "name": "Logistics Mk.3",
    "unlockName": "Logistics Mk.3",
    "description": "",
    "tier": 4,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SteelPlate_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_IronPlateReinforced_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_StorageContainerMk2_C",
          "Recipe_ConveyorBeltMk3_C",
          "Recipe_ConveyorLiftMk3_C",
          "Recipe_PipeSupportStackable_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_4-5_C",
    "name": "FICSIT Blueprints",
    "unlockName": "FICSIT Blueprints",
    "description": "This Build Gun software upgrade adds the Blueprint tab to the Build Menu. From the Blueprint tab, pioneers are able to access and organize the Blueprints created with the Blueprint Designer.",
    "tier": 4,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_SteelPlate_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_Cement_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_BlueprintDesigner_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_4-4_C",
    "name": "Hypertubes",
    "unlockName": "Hypertubes",
    "description": "",
    "tier": 4,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SteelPlateReinforced_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 300,
        "displayAmount": 300,
        "originalAmount": 300
      },
      {
        "resource": "Desc_CopperSheet_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PipeHyperStart_C",
          "Recipe_PipeHyper_C",
          "Recipe_PipeHyperSupport_C",
          "Recipe_HyperPoleStackable_C",
          "Recipe_HyperTubeJunction_C",
          "Recipe_HyperTubeTJunction_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_4-3_C",
    "name": "Expanded Power Infrastructure",
    "unlockName": "Expanded Power Infrastructure",
    "description": "",
    "tier": 4,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SteelPlateReinforced_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_SteelPlate_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 2000,
        "displayAmount": 2000,
        "originalAmount": 2000
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PowerStorageMk1_C",
          "Recipe_PowerTower_C",
          "Recipe_PowerTowerPlatform_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_4-2_C",
    "name": "Enhanced Asset Security",
    "unlockName": "Enhanced Asset Security",
    "description": "",
    "tier": 3,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronPlateReinforced_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_IronRod_C",
        "amount": 600,
        "displayAmount": 600,
        "originalAmount": 600
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 1500,
        "displayAmount": 1500,
        "originalAmount": 1500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_XenoBasher_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_3-3_C",
    "name": "Vehicular Transport",
    "unlockName": "Vehicular Transport",
    "description": "",
    "tier": 3,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_Rotor_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Tractor_C",
          "Recipe_TruckStation_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_3-2_C",
    "name": "Logistics Mk.2",
    "unlockName": "Logistics Mk.2",
    "description": "",
    "tier": 2,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronPlateReinforced_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Cement_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_IronRod_C",
        "amount": 300,
        "displayAmount": 300,
        "originalAmount": 300
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 300,
        "displayAmount": 300,
        "originalAmount": 300
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorBeltMk2_C",
          "Recipe_ConveyorPoleStackable_C",
          "Recipe_ConveyorLiftMk2_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_2-3_C",
    "name": "Jump Pads",
    "unlockName": "Jump Pads",
    "description": "",
    "tier": 2,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Rotor_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 300,
        "displayAmount": 300,
        "originalAmount": 300
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 150,
        "displayAmount": 150,
        "originalAmount": 150
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_JumpPadAdjustable_C",
          "Recipe_UJellyLandingPad_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_2-2_C",
    "name": "Obstacle Clearing",
    "unlockName": "Obstacle Clearing",
    "description": "",
    "tier": 2,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronScrew_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Cement_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Chainsaw_C",
          "Recipe_Biofuel_C"
        ]
      }
    ]
  },
  {
    "id": "Research_ACarapace_0_C",
    "name": "Hog Research",
    "unlockName": "Hog Research",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HogParts_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Protein_Hog_C"
        ]
      }
    ]
  },
  {
    "id": "Research_AOrgans_0_C",
    "name": "Spitter Research",
    "unlockName": "Spitter Research",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SpitterParts_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Protein_Spitter_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Alien_Somersloop_C",
    "name": "Somersloop Analysis",
    "unlockName": "Somersloop Analysis",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT1_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Mycelia_1_C",
    "name": "Mycelia",
    "unlockName": "Mycelia",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Mycelia_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Biomass_Mycelia_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Nutrients_0_C",
    "name": "Paleberry",
    "unlockName": "Paleberry",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Berry_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_PowerSlugs_3_C",
    "name": "Slug Scanning",
    "unlockName": "Slug Scanning",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronRod_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_IronScrew_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_PowerSlugs_1_C",
    "name": "Blue Power Slugs",
    "unlockName": "Blue Power Slugs",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Crystal_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PowerCrystalShard_1_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_1_C",
    "name": "Black Powder",
    "unlockName": "Black Powder",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Sulfur_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Coal_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Gunpowder_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_1-3_C",
    "name": "Field Research",
    "unlockName": "Field Research",
    "description": "",
    "tier": 1,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Wire_C",
        "amount": 300,
        "displayAmount": 300,
        "originalAmount": 300
      },
      {
        "resource": "Desc_IronScrew_C",
        "amount": 300,
        "displayAmount": 300,
        "originalAmount": 300
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Mam_C",
          "Recipe_ObjectScanner_C",
          "Recipe_StoragePlayer_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_1-2_C",
    "name": "Logistics",
    "unlockName": "Logistics",
    "description": "",
    "tier": 1,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronPlate_C",
        "amount": 150,
        "displayAmount": 150,
        "originalAmount": 150
      },
      {
        "resource": "Desc_IronRod_C",
        "amount": 150,
        "displayAmount": 150,
        "originalAmount": 150
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 300,
        "displayAmount": 300,
        "originalAmount": 300
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorAttachmentSplitter_C",
          "Recipe_ConveyorAttachmentMerger_C",
          "Recipe_ConveyorLiftMk1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_1-1_C",
    "name": "Base Building",
    "unlockName": "Base Building",
    "description": "",
    "tier": 1,
    "type": "Milestone",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Cement_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_IronRod_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_LookoutTower_C",
          "Recipe_Foundation_8x1_01_C",
          "Recipe_Foundation_8x2_01_C",
          "Recipe_Foundation_8x4_01_C",
          "Recipe_Ramp_8x1_01_C",
          "Recipe_Ramp_8x2_01_C",
          "Recipe_Ramp_8x4_01_C",
          "Recipe_Wall_8x4_01_C",
          "Recipe_Wall_Orange_8x1_C"
        ]
      }
    ]
  },
  {
    "id": "Research_AO_Stinger_C",
    "name": "Stinger Research",
    "unlockName": "Stinger Research",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_StingerParts_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Protein_Stinger_C"
        ]
      }
    ]
  },
  {
    "id": "Research_AO_Pre_Rebar_C",
    "name": "Structural Analysis",
    "unlockName": "Structural Analysis",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_AlienDNACapsule_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      },
      {
        "resource": "Desc_IronRod_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_AO_Hatcher_C",
    "name": "Hatcher Research",
    "unlockName": "Hatcher Research",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HatcherParts_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Protein_Crab_C"
        ]
      }
    ]
  },
  {
    "id": "Research_AO_DNACapsule_C",
    "name": "Bio-Organic Properties",
    "unlockName": "Bio-Organic Properties",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_AlienProtein_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_AlienDNACapsule_C",
          "Recipe_Biomass_AlienProtein_C"
        ]
      }
    ]
  },
  {
    "id": "Research_AOrgans_3_C",
    "name": "Inflated Pocket Dimension",
    "unlockName": "Inflated Pocket Dimension",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_AlienProtein_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_AOrgans_2_C",
    "name": "Protein Inhaler",
    "unlockName": "Protein Inhaler",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_AlienProtein_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      },
      {
        "resource": "Desc_Nut_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      },
      {
        "resource": "Desc_Rotor_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_MedicinalInhalerAlienOrgans_C"
        ]
      }
    ]
  },
  {
    "id": "Research_AOrgans_1_C",
    "name": "Discontinued - Organic Properties",
    "unlockName": "Discontinued - Organic Properties",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SpitterParts_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_AOrganisms_2_C",
    "name": "Hostile Organism Detection",
    "unlockName": "Hostile Organism Detection",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_AlienDNACapsule_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_CrystalOscillator_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      },
      {
        "resource": "Desc_HighSpeedConnector_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_AOrganisms_1_C",
    "name": "Discontinued - Object Scanner Improvements",
    "unlockName": "Discontinued - Object Scanner Improvements",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CrystalOscillator_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      },
      {
        "resource": "Desc_Stator_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "BP_EquipmentDescriptorObjectScanner_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_ACarapace_3_C",
    "name": "Expanded Toolbelt",
    "unlockName": "Expanded Toolbelt",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_AlienDNACapsule_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      },
      {
        "resource": "Desc_SteelPlate_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_ACarapace_2_1_C",
    "name": "Discontinued - Spiked Rebars",
    "unlockName": "Discontinued - Spiked Rebars",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Rotor_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_IronRod_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SpikedRebar_C"
        ]
      }
    ]
  },
  {
    "id": "Research_ACarapace_2_C",
    "name": "The Rebar Gun",
    "unlockName": "The Rebar Gun",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Rotor_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_IronPlateReinforced_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_IronScrew_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RebarGun_C",
          "Recipe_SpikedRebar_C"
        ]
      }
    ]
  },
  {
    "id": "Research_ACarapace_1_C",
    "name": "Discontinued - Structural Analysis",
    "unlockName": "Discontinued - Structural Analysis",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HogParts_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_SAMFluctuator_C",
    "name": "SAM Fluctuator",
    "unlockName": "SAM Fluctuator",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SAMIngot_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SAMFluctuator_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Alien_SAM_C",
    "name": "SAM Analysis",
    "unlockName": "SAM Analysis",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SAM_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_ProductionBooster_C",
    "name": "Production Amplifier",
    "unlockName": "Production Amplifier",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT1_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_CircuitBoard_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_PowerBooster_C",
    "name": "Power Augmenter",
    "unlockName": "Power Augmenter",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT1_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Computer_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_AlienPowerBuilding_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Alien_MercerSphere_C",
    "name": "Mercer Sphere Analysis",
    "unlockName": "Mercer Sphere Analysis",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT2_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_CentralUploadBoost_04_C",
    "name": "Upload Upgrade: 240/min",
    "unlockName": "Upload Upgrade: 240/min",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT2_C",
        "amount": 23,
        "displayAmount": 23,
        "originalAmount": 23
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 199,
        "displayAmount": 199,
        "originalAmount": 199
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_CentralUploadBoost_03_C",
    "name": "Upload Upgrade: 120/min",
    "unlockName": "Upload Upgrade: 120/min",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT2_C",
        "amount": 13,
        "displayAmount": 13,
        "originalAmount": 13
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 151,
        "displayAmount": 151,
        "originalAmount": 151
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_CentralUploadBoost_02_C",
    "name": "Upload Upgrade: 60/min",
    "unlockName": "Upload Upgrade: 60/min",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT2_C",
        "amount": 7,
        "displayAmount": 7,
        "originalAmount": 7
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 103,
        "displayAmount": 103,
        "originalAmount": 103
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_CentralUploadBoost_01_C",
    "name": "Upload Upgrade: 30/min",
    "unlockName": "Upload Upgrade: 30/min",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT2_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 47,
        "displayAmount": 47,
        "originalAmount": 47
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_CentralStorage_C",
    "name": "Dimensional Depot",
    "unlockName": "Dimensional Depot",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT2_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 11,
        "displayAmount": 11,
        "originalAmount": 11
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_CentralStorage_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Alien_CentralStackExpansion_04_C",
    "name": "Depot Expansion (500%)",
    "unlockName": "Depot Expansion (500%)",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT2_C",
        "amount": 23,
        "displayAmount": 23,
        "originalAmount": 23
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 199,
        "displayAmount": 199,
        "originalAmount": 199
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_CentralStackExpansion_03_C",
    "name": "Depot Expansion (400%)",
    "unlockName": "Depot Expansion (400%)",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT2_C",
        "amount": 13,
        "displayAmount": 13,
        "originalAmount": 13
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 151,
        "displayAmount": 151,
        "originalAmount": 151
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_CentralStackExpansion_02_C",
    "name": "Depot Expansion (300%)",
    "unlockName": "Depot Expansion (300%)",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT2_C",
        "amount": 7,
        "displayAmount": 7,
        "originalAmount": 7
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 103,
        "displayAmount": 103,
        "originalAmount": 103
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_CentralStackExpansion_01_C",
    "name": "Depot Expansion (200%)",
    "unlockName": "Depot Expansion (200%)",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT2_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 47,
        "displayAmount": 47,
        "originalAmount": 47
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_CentralInventory_C",
    "name": "Manual Depot Uploader",
    "unlockName": "Manual Depot Uploader",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_WAT2_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      },
      {
        "resource": "Desc_Computer_C",
        "amount": 17,
        "displayAmount": 17,
        "originalAmount": 17
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 29,
        "displayAmount": 29,
        "originalAmount": 29
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_BoosterFuel_C",
    "name": "Alien Power Matrix",
    "unlockName": "Alien Power Matrix",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SingularityCell_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_CrystalShard_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_AlienPowerFuel_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Alien_BoosterBlocker_C",
    "name": "Alien Energy Harnessing",
    "unlockName": "Alien Energy Harnessing",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SAMFluctuator_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Alien_ActiveSAM_C",
    "name": "SAM Reanimation",
    "unlockName": "SAM Reanimation",
    "description": "",
    "tier": null,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SAM_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_IngotSAM_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_7_2_C",
    "name": "Geothermal Generator",
    "unlockName": "Geothermal Generator",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HighSpeedConnector_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_HighSpeedWire_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      },
      {
        "resource": "Desc_Motor_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_GeneratorGeoThermal_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_7_1_C",
    "name": "Programmable Splitter",
    "unlockName": "Programmable Splitter",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CircuitBoardHighSpeed_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Computer_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_ModularFrameHeavy_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorAttachmentSplitterProgrammable_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_6_3_C",
    "name": "Bullet Guidance System",
    "unlockName": "Bullet Guidance System",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HighSpeedConnector_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_CartridgeStandard_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_CartridgeSmart_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_6_2_C",
    "name": "Power Poles Mk.3",
    "unlockName": "Power Poles Mk.3",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HighSpeedConnector_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PowerPoleMk3_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_5_1_C",
    "name": "Priority Power Switch",
    "unlockName": "Priority Power Switch",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HighSpeedConnector_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_HighSpeedWire_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PriorityPowerSwitch_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_4_3_C",
    "name": "Blade Runners",
    "unlockName": "Blade Runners",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Silica_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_BladeRunners_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_4_2_C",
    "name": "Power Poles Mk.2",
    "unlockName": "Power Poles Mk.2",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HighSpeedWire_C",
        "amount": 300,
        "displayAmount": 300,
        "originalAmount": 300
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PowerPoleMk2_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_4_1_2_C",
    "name": "Power Switch",
    "unlockName": "Power Switch",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_SteelPlate_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_CircuitBoardHighSpeed_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PowerSwitch_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_4_1_1_C",
    "name": "Smart Splitter",
    "unlockName": "Smart Splitter",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CircuitBoardHighSpeed_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_IronPlateReinforced_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorAttachmentSplitterSmart_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_3_2_C",
    "name": "Stun Rebar",
    "unlockName": "Stun Rebar",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HighSpeedWire_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_SpikedRebar_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Rebar_Stunshot_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_3_1_C",
    "name": "Inflated Pocket Dimension",
    "unlockName": "Inflated Pocket Dimension",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Silica_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Caterium_2_1_C",
    "name": "Zipline",
    "unlockName": "Zipline",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HighSpeedWire_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ZipLine_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Caterium_2_C",
    "name": "Quickwire",
    "unlockName": "Quickwire",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_GoldIngot_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Quickwire_C"
        ]
      }
    ]
  },
  {
    "id": "Research_HardDrive_0_C",
    "name": "Hard Drives",
    "unlockName": "Hard Drives",
    "description": "",
    "tier": null,
    "type": "HardDrive",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HardDrive_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Mycelia_GasMask_C",
    "name": "Gas Mask",
    "unlockName": "Gas Mask",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Coal_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_Fabric_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Gasmask_C",
          "Recipe_FilterGasMask_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Mycelia_8_C",
    "name": "Toxic Cellular Modification",
    "unlockName": "Toxic Cellular Modification",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_NobeliskExplosive_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_Mycelia_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_GenericBiomass_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_NobeliskGas_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Mycelia_7_C",
    "name": "Expanded Toolbelt",
    "unlockName": "Expanded Toolbelt",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Fabric_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Rotor_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Nutrients_2_C",
    "name": "Bacon Agaric",
    "unlockName": "Bacon Agaric",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Shroom_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Mycelia_6_C",
    "name": "Therapeutic Inhaler",
    "unlockName": "Therapeutic Inhaler",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Mycelia_C",
        "amount": 15,
        "displayAmount": 15,
        "originalAmount": 15
      },
      {
        "resource": "Desc_Shroom_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_AlienProtein_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_TherapeuticInhaler_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Mycelia_5_C",
    "name": "Vitamin Inhaler",
    "unlockName": "Vitamin Inhaler",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Mycelia_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_Berry_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_MedicinalInhaler_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Mycelia_4_C",
    "name": "Medical Properties",
    "unlockName": "Medical Properties",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Mycelia_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_Stator_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Mycelia_3_C",
    "name": "Parachute",
    "unlockName": "Parachute",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Fabric_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Parachute_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Mycelia_2_1_C",
    "name": "Synthetic Polyester Fabric",
    "unlockName": "Synthetic Polyester Fabric",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Fabric_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_PolymerResin_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_PolyesterFabric_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Mycelia_2_C",
    "name": "Fabric",
    "unlockName": "Fabric",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Mycelia_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_GenericBiomass_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Fabric_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Nutrients_4_C",
    "name": "Nutritional Inhaler",
    "unlockName": "Nutritional Inhaler",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Shroom_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      },
      {
        "resource": "Desc_Berry_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      },
      {
        "resource": "Desc_Nut_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_NutritionalInhaler_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Nutrients_3_C",
    "name": "Nutritional Processor",
    "unlockName": "Nutritional Processor",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Nutrients_1_C",
    "name": "Beryl Nut",
    "unlockName": "Beryl Nut",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Nut_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_PowerSlugs_6_C",
    "name": "Synthetic Power Shards",
    "unlockName": "Synthetic Power Shards",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CrystalShard_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_TimeCrystal_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_QuartzCrystal_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SyntheticPowerShard_C"
        ]
      }
    ]
  },
  {
    "id": "Research_PowerSlugs_5_C",
    "name": "Purple Power Slugs",
    "unlockName": "Purple Power Slugs",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Crystal_mk3_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_CopperSheet_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PowerCrystalShard_3_C"
        ]
      }
    ]
  },
  {
    "id": "Research_PowerSlugs_4_C",
    "name": "Yellow Power Slugs",
    "unlockName": "Yellow Power Slugs",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Crystal_mk2_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_Rotor_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PowerCrystalShard_2_C"
        ]
      }
    ]
  },
  {
    "id": "Research_PowerSlugs_2_C",
    "name": "Overclock Production",
    "unlockName": "Overclock Production",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CrystalShard_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Quartz_PriorityMerger_C",
    "name": "Material Resonance Screening",
    "unlockName": "Material Resonance Screening",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CrystalOscillator_C",
        "amount": 15,
        "displayAmount": 15,
        "originalAmount": 15
      },
      {
        "resource": "Desc_IronPlateReinforced_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorAttachmentMergerPriority_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Quartz_4_C",
    "name": "Radar Technology",
    "unlockName": "Radar Technology",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CrystalOscillator_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_ModularFrameHeavy_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Computer_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RadarTower_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Quartz_3_4_C",
    "name": "Explosive Resonance Application",
    "unlockName": "Explosive Resonance Application",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CrystalOscillator_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      },
      {
        "resource": "Desc_NobeliskExplosive_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_NobeliskShockwave_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Quartz_3_1_C",
    "name": "The Explorer",
    "unlockName": "The Explorer",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CrystalOscillator_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Explorer_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Quartz_3_C",
    "name": "Signal Systems",
    "unlockName": "Signal Systems",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CrystalOscillator_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      },
      {
        "resource": "Desc_CircuitBoard_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Quartz_2_1_C",
    "name": "Shatter Rebar",
    "unlockName": "Shatter Rebar",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_QuartzCrystal_C",
        "amount": 30,
        "displayAmount": 30,
        "originalAmount": 30
      },
      {
        "resource": "Desc_SpikedRebar_C",
        "amount": 150,
        "displayAmount": 150,
        "originalAmount": 150
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Rebar_Spreadshot_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_ExperimentalPower_C",
    "name": "Experimental Power Generation",
    "unlockName": "Experimental Power Generation",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Sulfur_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_ModularFrame_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Rotor_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Sulfur_CompactedCoal_C",
    "name": "Compacted Coal",
    "unlockName": "Compacted Coal",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_HardDrive_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_Sulfur_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      },
      {
        "resource": "Desc_Coal_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Alternate_EnrichedCoal_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_Alternate_EnrichedCoal_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_6_C",
    "name": "Inflated Pocket Dimension",
    "unlockName": "Inflated Pocket Dimension",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_GunpowderMK2_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Computer_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Sulfur_5_2_Hidden_C",
    "name": "Packaged Turbo Rifle Ammo",
    "unlockName": "Packaged Turbo Rifle Ammo",
    "description": "",
    "tier": 3,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_CartridgeChaos_Packaged_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_5_2_C",
    "name": "Turbo Rifle Ammo",
    "unlockName": "Turbo Rifle Ammo",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CartridgeStandard_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      },
      {
        "resource": "Desc_TurboFuel_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_AluminumCasing_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_CartridgeChaos_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "Research_Sulfur_5_2_Hidden_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_5_1_C",
    "name": "Nuclear Deterrent Development",
    "unlockName": "Nuclear Deterrent Development",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_NobeliskExplosive_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_UraniumCell_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      },
      {
        "resource": "Desc_CircuitBoardHighSpeed_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_NobeliskNuke_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_5_C",
    "name": "Expanded Toolbelt",
    "unlockName": "Expanded Toolbelt",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Gunpowder_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_SteelPlateReinforced_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Sulfur_4_2_1_C",
    "name": "Discontinued - Rifle Cartridges",
    "unlockName": "Discontinued - Rifle Cartridges",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Gunpowder_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_Rubber_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Cartridge_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_4_2_C",
    "name": "Explosive Rebar",
    "unlockName": "Explosive Rebar",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_GunpowderMK2_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_SpikedRebar_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_SteelPlate_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Rebar_Explosive_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_4_1_C",
    "name": "The Rifle",
    "unlockName": "The Rifle",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_GunpowderMK2_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Motor_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Rubber_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SpaceRifleMk1_C",
          "Recipe_Cartridge_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_4_C",
    "name": "Cluster Nobelisk",
    "unlockName": "Cluster Nobelisk",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_GunpowderMK2_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_NobeliskExplosive_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_NobeliskCluster_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_3_2_1_C",
    "name": "Discontinued - Nobelisk Explosives",
    "unlockName": "Discontinued - Nobelisk Explosives",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Gunpowder_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Nobelisk_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_3_2_C",
    "name": "",
    "unlockName": "",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Gunpowder_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": []
  },
  {
    "id": "Research_Sulfur_3_1_C",
    "name": "The Nobelisk Detonator",
    "unlockName": "The Nobelisk Detonator",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Gunpowder_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_SteelPipe_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_NobeliskDetonator_C",
          "Recipe_Nobelisk_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_3_C",
    "name": "Smokeless Powder",
    "unlockName": "Smokeless Powder",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Gunpowder_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Plastic_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_GunpowderMK2_C"
        ]
      }
    ]
  },
  {
    "id": "Research_Sulfur_2_C",
    "name": "Volatile Applications",
    "unlockName": "Volatile Applications",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Gunpowder_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": []
  },
  {
    "id": "Schematic_XMassTree_T4_C",
    "name": "",
    "unlockName": "",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Research_XMas_5_C",
    "name": "Giant FICSMAS Tree: Upgrade 4",
    "unlockName": "Giant FICSMAS Tree: Upgrade 4",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_XmasStar_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_XMassTree_T4_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_XMassTree_T3_C",
    "name": "",
    "unlockName": "",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Research_XMas_4_C",
    "name": "Giant FICSMAS Tree: Upgrade 3",
    "unlockName": "Giant FICSMAS Tree: Upgrade 3",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_XmasDataCartridge4_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_XmasBranch_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_XmasBallCluster_C",
        "amount": 400,
        "displayAmount": 400,
        "originalAmount": 400
      }
    ],
    "unlocks": [
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_XMassTree_T3_C"
        ]
      },
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_XmasWreath_C"
        ]
      }
    ]
  },
  {
    "id": "Research_XMas_4-2_C",
    "name": "Snowfight!",
    "unlockName": "Snowfight!",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Snow_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_CandyCane_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      },
      {
        "resource": "Desc_XmasBow_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Snowball_C"
        ]
      }
    ]
  },
  {
    "id": "Research_XMas_4-1_C",
    "name": "FICSMAS Decoration",
    "unlockName": "FICSMAS Decoration",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_XmasWreath_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_XmasBallCluster_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_XmasBow_C",
        "amount": 500,
        "displayAmount": 500,
        "originalAmount": 500
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_WreathDecor_C",
          "Recipe_XmasStar_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_XMassTree_T2_C",
    "name": "",
    "unlockName": "",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Research_XMas_3_C",
    "name": "Giant FICSMAS Tree: Upgrade 2",
    "unlockName": "Giant FICSMAS Tree: Upgrade 2",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_XmasDataCartridge3_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_XmasBall1_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_XmasBall2_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_Gift_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": [
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_XMassTree_T2_C"
        ]
      },
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_XmasBall3_C",
          "Recipe_XmasBall4_C"
        ]
      }
    ]
  },
  {
    "id": "Research_XMas_3-2_C",
    "name": "It's Snowing!",
    "unlockName": "It's Snowing!",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_Snow_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_XmasBall3_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_XmasBall4_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      },
      {
        "resource": "Desc_CandyCane_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SnowDispenser_C",
          "Recipe_SnowCannon_C"
        ]
      }
    ]
  },
  {
    "id": "Research_XMas_3-1_C",
    "name": "FICSMAS Lights",
    "unlockName": "FICSMAS Lights",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_XmasBall1_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_XmasBall2_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_XmasBall3_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_XmasBall4_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_xmassLights_C",
          "Recipe_XmasBallCluster_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_XMassTree_T1_C",
    "name": "",
    "unlockName": "",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Research_XMas_2_C",
    "name": "Giant FICSMAS Tree: Upgrade 1",
    "unlockName": "Giant FICSMAS Tree: Upgrade 1",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_XmasDataCartridge2_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      },
      {
        "resource": "Desc_CandyCane_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      },
      {
        "resource": "Desc_XmasBow_C",
        "amount": 30,
        "displayAmount": 30,
        "originalAmount": 30
      }
    ],
    "unlocks": [
      {
        "type": "Schematic",
        "scripts": [
          "Schematic_XMassTree_T1_C"
        ]
      },
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_XmasBall1_C",
          "Recipe_XmasBall2_C"
        ]
      }
    ]
  },
  {
    "id": "Research_XMas_2-2_C",
    "name": "FICSMAS Gift Tree",
    "unlockName": "FICSMAS Gift Tree",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_XmasBall1_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_XmasBall2_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_XmasBranch_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_TreeGiftProducer_C"
        ]
      }
    ]
  },
  {
    "id": "Research_XMas_2-1_C",
    "name": "A Friend",
    "unlockName": "A Friend",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CandyCane_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_XmasBow_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Snowman_C",
          "Recipe_Snow_C"
        ]
      }
    ]
  },
  {
    "id": "Research_XMas_1_C",
    "name": "FICSMAS Tree Base",
    "unlockName": "FICSMAS Tree Base",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_XmasDataCartridge1_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_XMassTree_C",
          "Recipe_XmasBranch_C"
        ]
      }
    ]
  },
  {
    "id": "Research_XMas_1-2_C",
    "name": "Candy Cane Decor",
    "unlockName": "Candy Cane Decor",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_CandyCane_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_CandyCaneDecor_C",
          "Recipe_XmasBow_C"
        ]
      }
    ]
  },
  {
    "id": "Research_XMas_1-1_C",
    "name": "Candy Cane Basher",
    "unlockName": "Candy Cane Basher",
    "description": "",
    "tier": 3,
    "type": "MAM",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_XmasBranch_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_CandyCaneBasher_C",
          "Recipe_CandyCane_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Colour_ConcreteSwatch_C",
    "name": "Concrete Color Swatch background unlock",
    "unlockName": "Concrete Color Swatch background unlock",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Swatch_Concrete_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Concrete_Walls_Basic_C",
    "name": "Basic Concrete Walls",
    "unlockName": "Basic Concrete Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Concrete_8x1_C",
          "Recipe_Wall_Concrete_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Customizer_ConcreteWallMaterial_C",
    "name": "Concrete Wall Material",
    "unlockName": "Concrete Wall Material",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_1-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Material_Wall_Concrete_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Concrete_Walls_Basic_C",
          "CBG_Concrete_Walls_Conveyor_C",
          "CBG_Concrete_Walls_DiagonalDown_C",
          "CBG_Concrete_Walls_DiagonalUp_C",
          "CBG_Concrete_Walls_Doors_C",
          "CBG_Concrete_Walls_Gates_C",
          "CBG_Concrete_Walls_Tilted_C",
          "CBG_Concrete_Walls_Windows_C",
          "CBG_Colour_ConcreteSwatch_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Concrete_Walls_Conveyor_C",
    "name": "Conveyor Concrete Walls",
    "unlockName": "Conveyor Concrete Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_ConcreteWallMaterial_C",
      "ResourceSink_ConveryWalls_Normal_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Concrete_8x4_ConveyorHole_01_C",
          "Recipe_Wall_Concrete_8x4_ConveyorHole_02_C",
          "Recipe_Wall_Concrete_8x4_ConveyorHole_03_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Steel_Walls_Basic_C",
    "name": "Basic Steel Walls",
    "unlockName": "Basic Steel Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SteelWall_8x1_C",
          "Recipe_Wall_8x4_02_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Steel_Walls_Conveyor_C",
    "name": "Conveyor Steel Walls",
    "unlockName": "Conveyor Steel Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_SteelWallMaterial_C",
      "ResourceSink_ConveryWalls_Normal_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Conveyor_8x4_01_Steel_C",
          "Recipe_Wall_Conveyor_8x4_02_Steel_C",
          "Recipe_Wall_Conveyor_8x4_03_Steel_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Customizer_SteelWallMaterial_C",
    "name": "Steel Wall Material",
    "unlockName": "Steel Wall Material",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C",
      "Schematic_1-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Material_Wall_Steel_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Steel_Walls_Basic_C",
          "CBG_Steel_Walls_Conveyor_C",
          "CBG_Steel_Walls_DiagonalDown_C",
          "CBG_Steel_Walls_DiagonalUp_C",
          "CBG_Steel_Walls_Doors_C",
          "CBG_Steel_Walls_Gates_C",
          "CBG_Steel_Walls_Tilted_C",
          "CBG_Steel_Walls_WIndows_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Diagonal_Down_Wallset_C",
    "name": "Inverted Ramp Wall Bundle",
    "unlockName": "Inverted Ramp Wall Bundle",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Orange_FlipTris_8x1_C",
          "Recipe_Wall_Orange_FlipTris_8x2_C",
          "Recipe_Wall_Orange_FlipTris_8x4_C",
          "Recipe_Wall_Orange_FlipTris_8x8_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Concrete_Walls_DiagonalDown_C",
          "CBG_Steel_Walls_DiagonalDown_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Concrete_Walls_DiagonalDown_C",
    "name": "Down Diagonal Concrete Walls",
    "unlockName": "Down Diagonal Concrete Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_ConcreteWallMaterial_C",
      "ResourceSink_Diagonal_Down_Wallset_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Concrete_FlipTris_8x1_C",
          "Recipe_Wall_Concrete_FlipTris_8x2_C",
          "Recipe_Wall_Concrete_FlipTris_8x4_C",
          "Recipe_Wall_Concrete_FlipTris_8x8_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Steel_Walls_DiagonalDown_C",
    "name": "Down Diagonal Steel Walls",
    "unlockName": "Down Diagonal Steel Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_SteelWallMaterial_C",
      "ResourceSink_Diagonal_Down_Wallset_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SteelWall_FlipTris_8x1_C",
          "Recipe_SteelWall_FlipTris_8x2_C",
          "Recipe_SteelWall_FlipTris_8x4_C",
          "Recipe_SteelWall_FlipTris_8x8_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Diagonal_Up_WallSet_C",
    "name": "Ramp Wall Bundle",
    "unlockName": "Ramp Wall Bundle",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Orange_Tris_8x1_C",
          "Recipe_Wall_Orange_Tris_8x2_C",
          "Recipe_Wall_Orange_Tris_8x4_C",
          "Recipe_Wall_Orange_Tris_8x8_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Steel_Walls_DiagonalUp_C",
          "CBG_Concrete_Walls_DiagonalUp_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Concrete_Walls_DiagonalUp_C",
    "name": "Up Diagonal Concrete Walls",
    "unlockName": "Up Diagonal Concrete Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_ConcreteWallMaterial_C",
      "ResourceSink_Diagonal_Up_WallSet_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Concrete_Tris_8x1_C",
          "Recipe_Wall_Concrete_Tris_8x2_C",
          "Recipe_Wall_Concrete_Tris_8x4_C",
          "Recipe_Wall_Concrete_Tris_8x8_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Steel_Walls_DiagonalUp_C",
    "name": "Up Diagonal Steel Walls",
    "unlockName": "Up Diagonal Steel Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_SteelWallMaterial_C",
      "ResourceSink_Diagonal_Up_WallSet_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SteelWall_Tris_8x1_C",
          "Recipe_SteelWall_Tris_8x2_C",
          "Recipe_SteelWall_Tris_8x4_C",
          "Recipe_SteelWall_Tris_8x8_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_DoorWalls_Normal_C",
    "name": "Door Walls",
    "unlockName": "Door Walls",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Door_8x4_01_C",
          "Recipe_Wall_Door_8x4_03_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Concrete_Walls_Doors_C",
          "CBG_Steel_Walls_Doors_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Concrete_Walls_Doors_C",
    "name": "Doors Concrete Walls",
    "unlockName": "Doors Concrete Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_ConcreteWallMaterial_C",
      "ResourceSink_DoorWalls_Normal_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Concrete_CDoor_8x4_C",
          "Recipe_Wall_Concrete_SDoor_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Steel_Walls_Doors_C",
    "name": "Doors Steel Walls",
    "unlockName": "Doors Steel Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_SteelWallMaterial_C",
      "ResourceSink_DoorWalls_Normal_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Door_8x4_01_Steel_C",
          "Recipe_Wall_Door_8x4_03_Steel_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_FactoryRailing_C",
    "name": "Industrial Railing",
    "unlockName": "Industrial Railing",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Fence_01_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_FactoryFence_C",
    "name": "Modern Railing",
    "unlockName": "Modern Railing",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Railing_01_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_FrameworkFoundations_C",
    "name": "Structural Frame Set",
    "unlockName": "Structural Frame Set",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Flat_Frame_01_C",
          "Recipe_FoundationGlass_01_C",
          "Recipe_Foundation_Frame_01_C",
          "Recipe_Wall_Frame_01_C",
          "Recipe_Ramp_Frame_01_C",
          "Recipe_Ramp_Frame_Inverted_01_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_FoudationPillar_C",
    "name": "Metal Pillar Set",
    "unlockName": "Metal Pillar Set",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PillarMiddle_C",
          "Recipe_PillarBase_C",
          "Recipe_Pillar_Small_Metal_C",
          "Recipe_PillarBase_Small_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Customizer_Asphalt_FoundationMaterial_C",
    "name": "Asphalt Foundation Material",
    "unlockName": "Asphalt Foundation Material",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_1-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Material_Foundation_Asphalt_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Foundations_Asphalt_C",
          "CBG_Ramps_Corners_Asphalt_C",
          "CBG_Ramps_Double_Asphalt_C",
          "CBG_Ramps_InvCorners_Asphalt_C",
          "CBG_Ramps_Inverted_Asphalt_C",
          "CBG_QuarterPipes_Asphalt_C",
          "CBG_Half_Foundations_Asphalt_C",
          "CBG_ExtensionQuarterPipes_Asphalt_C",
          "CBG_Stairs_Asphalt_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_ExtensionQuarterPipes_Asphalt_C",
    "name": "Asphalt Quarter PIpe Extensions",
    "unlockName": "Asphalt Quarter PIpe Extensions",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Asphalt_FoundationMaterial_C",
      "ResourceSink_QuarterPipeExtensions_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuarterPipeMiddleInCorner_Asphalt_8x1_C",
          "Recipe_QuarterPipeMiddleInCorner_Asphalt_8x2_C",
          "Recipe_QuarterPipeMiddleInCorner_Asphalt_8x4_C",
          "Recipe_QuarterPipeMiddleOutCorner_Asphalt_4x1_C",
          "Recipe_QuarterPipeMiddleOutCorner_Asphalt_4x2_C",
          "Recipe_QuarterPipeMiddleOutCorner_Asphalt_4x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Foundations_Asphalt_C",
    "name": "Asphalt Foundations & Basic Ramps",
    "unlockName": "Asphalt Foundations & Basic Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Foundation_Asphalt_8x1_C",
          "Recipe_Foundation_Asphalt_8x2_C",
          "Recipe_Foundation_Asphalt_8x4_C",
          "Recipe_Ramp_Asphalt_8x1_C",
          "Recipe_Ramp_Asphalt_8x2_C",
          "Recipe_Ramp_Asphalt_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Corners_Asphalt_C",
    "name": "Asphalt Corner Ramps",
    "unlockName": "Asphalt Corner Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Asphalt_FoundationMaterial_C",
      "ResourceSink_DiagonalRamps_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Ramp_DownCorner_Asphalt_8x1_C",
          "Recipe_Ramp_DownCorner_Asphalt_8x2_C",
          "Recipe_Ramp_DownCorner_Asphalt_8x4_C",
          "Recipe_Ramp_UpCorner_Asphalt_8x1_C",
          "Recipe_Ramp_UpCorner_Asphalt_8x2_C",
          "Recipe_Ramp_UpCorner_Asphalt_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_DiagonalRamps_C",
    "name": "Corner Ramp Pack",
    "unlockName": "Corner Ramp Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Ramp_Diagonal_8x1_02_C",
          "Recipe_Ramp_Diagonal_8x2_02_C",
          "Recipe_Ramp_Diagonal_8x4_02_C",
          "Recipe_Ramp_Diagonal_8x1_01_C",
          "Recipe_Ramp_Diagonal_8x2_01_C",
          "Recipe_Ramp_Diagonal_8x4_01_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Ramps_Corners_Concrete_C",
          "CBG_Ramps_Corners_Metal_C",
          "CBG_Ramps_Corners_Coated_C",
          "CBG_Ramps_Corners_Asphalt_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Customizer_Concrete_FoundationMaterial_C",
    "name": "Concrete Foundation Material",
    "unlockName": "Concrete Foundation Material",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_1-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Material_Foundation_Concrete_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Foundations_Concrete_C",
          "CBG_Ramps_Corners_Concrete_C",
          "CBG_Ramps_Double_Concrete_C",
          "CBG_Ramps_InvCorners_Concrete_C",
          "CBG_Ramps_Inverted_Concrete_C",
          "CBG_QuarterPipes_Concrete_C",
          "CBG_Colour_ConcreteSwatch_C",
          "CBG_Half_Foundations_Concrete_C",
          "CBG_ExtensionQuarterPipes_Concrete_C",
          "CBG_Stairs_Concrete_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_ExtensionQuarterPipes_Concrete_C",
    "name": "Concrete Quarter PIpe Extensions",
    "unlockName": "Concrete Quarter PIpe Extensions",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Concrete_FoundationMaterial_C",
      "ResourceSink_QuarterPipeExtensions_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuarterPipeMiddleInCorner_Concrete_8x1_C",
          "Recipe_QuarterPipeMiddleInCorner_Concrete_8x2_C",
          "Recipe_QuarterPipeMiddleInCorner_Concrete_8x4_C",
          "Recipe_QuarterPipeMiddleOutCorner_Concrete_4x1_C",
          "Recipe_QuarterPipeMiddleOutCorner_Concrete_4x2_C",
          "Recipe_QuarterPipeMiddleOutCorner_Concrete_4x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Foundations_Concrete_C",
    "name": "Concrete Foundations & Basic Ramps",
    "unlockName": "Concrete Foundations & Basic Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Foundation_Concrete_8x1_C",
          "Recipe_Foundation_Concrete_8x2_C",
          "Recipe_Foundation_Concrete_8x4_C",
          "Recipe_Ramp_Concrete_8x1_C",
          "Recipe_Ramp_Concrete_8x2_C",
          "Recipe_Ramp_Concrete_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Corners_Concrete_C",
    "name": "Concrete Corner Ramps",
    "unlockName": "Concrete Corner Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Concrete_FoundationMaterial_C",
      "ResourceSink_DiagonalRamps_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Ramp_DownCorner_Concrete_8x1_C",
          "Recipe_Ramp_DownCorner_Concrete_8x2_C",
          "Recipe_Ramp_DownCorner_Concrete_8x4_C",
          "Recipe_Ramp_UpCorner_Concrete_8x1_C",
          "Recipe_Ramp_UpCorner_Concrete_8x2_C",
          "Recipe_Ramp_UpCorner_Concrete_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_FoundationExpansionPack_C",
    "name": "Double Ramp Set",
    "unlockName": "Double Ramp Set",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RampDouble_8x1_C",
          "Recipe_RampDouble_C",
          "Recipe_Ramp_8x8x8_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Ramps_Double_Concrete_C",
          "CBG_Ramps_Double_Metal_C",
          "CBG_Ramps_Double_Coated_C",
          "CBG_Ramps_Double_Asphalt_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Double_Asphalt_C",
    "name": "Asphalt Double Ramps",
    "unlockName": "Asphalt Double Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Asphalt_FoundationMaterial_C",
      "ResourceSink_FoundationExpansionPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RampDouble_Asphalt_8x1_C",
          "Recipe_RampDouble_Asphalt_8x2_C",
          "Recipe_RampDouble_Asphalt_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Double_Concrete_C",
    "name": "Concrete Double Ramps",
    "unlockName": "Concrete Double Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Concrete_FoundationMaterial_C",
      "ResourceSink_FoundationExpansionPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RampDouble_Concrete_8x1_C",
          "Recipe_RampDouble_Concrete_8x2_C",
          "Recipe_RampDouble_Concrete_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Customizer_GripMetal_FoundationMaterial_C",
    "name": "Grip Metal Foundation Material",
    "unlockName": "Grip Metal Foundation Material",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C",
      "Schematic_1-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Material_Foundation_GripMetal_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Foundations_Metal_C",
          "CBG_Ramps_Corners_Metal_C",
          "CBG_Ramps_Double_Metal_C",
          "CBG_Ramps_InvCorners_Metal_C",
          "CBG_Ramps_Inverted_Metal_C",
          "CBG_QuarterPipes_GripMetal_C",
          "CBG_Half_Foundations_Metal_C",
          "CBG_ExtensionQuarterPipes_GripMetal_C",
          "CBG_Stairs_Metal_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_ExtensionQuarterPipes_GripMetal_C",
    "name": "Grip Metal Quarter PIpe Extensions",
    "unlockName": "Grip Metal Quarter PIpe Extensions",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_GripMetal_FoundationMaterial_C",
      "ResourceSink_QuarterPipeExtensions_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuarterPipeMiddleInCorner_Grip_8x1_C",
          "Recipe_QuarterPipeMiddleInCorner_Grip_8x2_C",
          "Recipe_QuarterPipeMiddleInCorner_Grip_8x4_C",
          "Recipe_QuarterPipeMiddleOutCorner_Grip_4x1_C",
          "Recipe_QuarterPipeMiddleOutCorner_Grip_4x2_C",
          "Recipe_QuarterPipeMiddleOutCorner_Grip_4x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Foundations_Metal_C",
    "name": "Metal Foundations & Basic Ramps",
    "unlockName": "Metal Foundations & Basic Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Foundation_Metal_8x1_C",
          "Recipe_Foundation_Metal_8x2_C",
          "Recipe_Foundation_Metal_8x4_C",
          "Recipe_Ramp_Metal_8x1_C",
          "Recipe_Ramp_Metal_8x2_C",
          "Recipe_Ramp_Metal_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Corners_Metal_C",
    "name": "Metal Corner Ramps",
    "unlockName": "Metal Corner Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_GripMetal_FoundationMaterial_C",
      "ResourceSink_DiagonalRamps_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Ramp_DownCorner_Metal_8x1_C",
          "Recipe_Ramp_DownCorner_Metal_8x2_C",
          "Recipe_Ramp_DownCorner_Metal_8x4_C",
          "Recipe_Ramp_UpCorner_Metal_8x1_C",
          "Recipe_Ramp_UpCorner_Metal_8x2_C",
          "Recipe_Ramp_UpCorner_Metal_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Double_Metal_C",
    "name": "Metal Double Ramps",
    "unlockName": "Metal Double Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_GripMetal_FoundationMaterial_C",
      "ResourceSink_FoundationExpansionPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RampDouble_Metal_8x1_C",
          "Recipe_RampDouble_Metal_8x2_C",
          "Recipe_RampDouble_Metal_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_InvertedCornerRamps_C",
    "name": "Inverted Corner Ramp Pack",
    "unlockName": "Inverted Corner Ramp Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RampInverted_8x1_Corner_01_C",
          "Recipe_RampInverted_8x2_Corner_01_C",
          "Recipe_RampInverted_8x4_Corner_01_C",
          "Recipe_RampInverted_8x1_Corner_02_C",
          "Recipe_RampInverted_8x2_Corner_02_C",
          "Recipe_RampInverted_8x4_Corner_02_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Ramps_InvCorners_Concrete_C",
          "CBG_Ramps_InvCorners_Metal_C",
          "CBG_Ramps_InvCorners_Coated_C",
          "CBG_Ramps_InvCorners_Asphalt_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_InvCorners_Asphalt_C",
    "name": "Asphalt Inverted corner Ramps",
    "unlockName": "Asphalt Inverted corner Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Asphalt_FoundationMaterial_C",
      "ResourceSink_InvertedCornerRamps_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_InvertedRamp_DCorner_Asphalt_8x1_C",
          "Recipe_InvertedRamp_DCorner_Asphalt_8x2_C",
          "Recipe_InvertedRamp_DCorner_Asphalt_8x4_C",
          "Recipe_InvertedRamp_UCorner_Asphalt_8x1_C",
          "Recipe_InvertedRamp_UCorner_Asphalt_8x2_C",
          "Recipe_InvertedRamp_UCorner_Asphalt_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_InvCorners_Concrete_C",
    "name": "Concrete Inverted corner Ramps",
    "unlockName": "Concrete Inverted corner Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Concrete_FoundationMaterial_C",
      "ResourceSink_InvertedCornerRamps_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_InvertedRamp_DCorner_Concrete_8x1_C",
          "Recipe_InvertedRamp_DCorner_Concrete_8x2_C",
          "Recipe_InvertedRamp_DCorner_Concrete_8x4_C",
          "Recipe_InvertedRamp_UCorner_Concrete_8x1_C",
          "Recipe_InvertedRamp_UCorner_Concrete_8x2_C",
          "Recipe_InvertedRamp_UCorner_Concrete_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_InvCorners_Metal_C",
    "name": "Metal Inverted Corner Ramps",
    "unlockName": "Metal Inverted Corner Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_GripMetal_FoundationMaterial_C",
      "ResourceSink_InvertedCornerRamps_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_InvertedRamp_DCorner_Metal_8x1_C",
          "Recipe_InvertedRamp_DCorner_Metal_8x2_C",
          "Recipe_InvertedRamp_DCorner_Metal_8x4_C",
          "Recipe_InvertedRamp_UCorner_Metal_8x1_C",
          "Recipe_InvertedRamp_UCorner_Metal_8x2_C",
          "Recipe_InvertedRamp_UCorner_Metal_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Customizer_PolishedConcrete_FoundationMaterial_C",
    "name": "Coated Concrete Foundation Material",
    "unlockName": "Coated Concrete Foundation Material",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C",
      "Schematic_1-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 6,
        "displayAmount": 6,
        "originalAmount": 6
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Material_Foundation_PolishedConcrete_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Foundations_Coated_C",
          "CBG_Ramps_Corners_Coated_C",
          "CBG_Ramps_Double_Coated_C",
          "CBG_Ramps_InvCorners_Coated_C",
          "CBG_Ramps_Inverted_Coated_C",
          "CBG_QuarterPipes_Coated_C",
          "CBG_Colour_ConcreteSwatch_C",
          "CBG_Half_Foundations_Polished_C",
          "CBG_ExtensionQuarterPipes_Polished_C",
          "CBG_Stairs_Coated_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_ExtensionQuarterPipes_Polished_C",
    "name": "Polished Concrete Quarter PIpe Extensions",
    "unlockName": "Polished Concrete Quarter PIpe Extensions",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_PolishedConcrete_FoundationMaterial_C",
      "ResourceSink_QuarterPipeExtensions_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuarterPipeMiddleInCorner_PolishedConcrete_8x1_C",
          "Recipe_QuarterPipeMiddleInCorner_PolishedConcrete_8x2_C",
          "Recipe_QuarterPipeMiddleInCorner_PolishedConcrete_8x4_C",
          "Recipe_QuarterPipeMiddleOutCorner_PolishedConcrete_4x1_C",
          "Recipe_QuarterPipeMiddleOutCorner_PolishedConcrete_4x2_C",
          "Recipe_QuarterPipeMiddleOutCorner_PolishedConcrete_4x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Foundations_Coated_C",
    "name": "Coated Concrete Foundations & Basic Ramps",
    "unlockName": "Coated Concrete Foundations & Basic Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Foundation_ConcretePolished_8x1_C",
          "Recipe_Foundation_ConcretePolished_8x2_C",
          "Recipe_Foundation_ConcretePolished_8x4_C",
          "Recipe_Ramp_Polished_8x1_C",
          "Recipe_Ramp_Polished_8x2_C",
          "Recipe_Ramp_Polished_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Corners_Coated_C",
    "name": "Coated Concrete Corner Ramps",
    "unlockName": "Coated Concrete Corner Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_PolishedConcrete_FoundationMaterial_C",
      "ResourceSink_DiagonalRamps_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Ramp_UpCorner_Polished_8x1_C",
          "Recipe_Ramp_UpCorner_Polished_8x2_C",
          "Recipe_Ramp_UpCorner_Polished_8x4_C",
          "Recipe_Ramp_DownCorner_Polished_8x1_C",
          "Recipe_Ramp_DownCorner_Polished_8x2_C",
          "Recipe_Ramp_DownCorner_Polished_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Double_Coated_C",
    "name": "Coated Concrete Double Ramps",
    "unlockName": "Coated Concrete Double Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_PolishedConcrete_FoundationMaterial_C",
      "ResourceSink_FoundationExpansionPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RampDouble_Polished_8x1_C",
          "Recipe_RampDouble_Polished_8x2_C",
          "Recipe_RampDouble_Polished_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_InvCorners_Coated_C",
    "name": "Coated Concrete Inverted Corner Ramps",
    "unlockName": "Coated Concrete Inverted Corner Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_PolishedConcrete_FoundationMaterial_C",
      "ResourceSink_InvertedCornerRamps_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_InvertedRamp_DCorner_Polished_8x1_C",
          "Recipe_InvertedRamp_DCorner_Polished_8x2_C",
          "Recipe_InvertedRamp_DCorner_Polished_8x4_C",
          "Recipe_InvertedRamp_UCorner_Polished_8x1_C",
          "Recipe_InvertedRamp_UCorner_Polished_8x2_C",
          "Recipe_InvertedRamp_UCorner_Polished_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Inverted_Coated_C",
    "name": "Coated Concrete Inverted Ramps",
    "unlockName": "Coated Concrete Inverted Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_PolishedConcrete_FoundationMaterial_C",
      "ResourceSink_InvertedRampPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_InvertedRamp_Polished_8x1_C",
          "Recipe_InvertedRamp_Polished_8x2_C",
          "Recipe_InvertedRamp_Polished_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_InvertedRampPack_C",
    "name": "Inverted Ramp Set",
    "unlockName": "Inverted Ramp Set",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_RampInverted_8x1_C",
          "Recipe_RampInverted_8x2_01_C",
          "Recipe_Ramp_8x4_Inverted_01_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Ramps_Inverted_Concrete_C",
          "CBG_Ramps_Inverted_Metal_C",
          "CBG_Ramps_Inverted_Coated_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Inverted_Concrete_C",
    "name": "Concrete Inverted Ramps",
    "unlockName": "Concrete Inverted Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Concrete_FoundationMaterial_C",
      "ResourceSink_InvertedRampPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_InvertedRamp_Concrete_8x1_C",
          "Recipe_InvertedRamp_Concrete_8x2_C",
          "Recipe_InvertedRamp_Concrete_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Inverted_Metal_C",
    "name": "Metal Inverted Ramps",
    "unlockName": "Metal Inverted Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_GripMetal_FoundationMaterial_C",
      "ResourceSink_InvertedRampPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_InvertedRamp_Metal_8x1_C",
          "Recipe_InvertedRamp_Metal_8x2_C",
          "Recipe_InvertedRamp_Metal_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Ladders_C",
    "name": "Factory Ladder",
    "unlockName": "Factory Ladder",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Ladder_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Walkways_C",
    "name": "Industrial Walkways",
    "unlockName": "Industrial Walkways",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Walkway_Straight_C",
          "Recipe_Walkway_Cross_C",
          "Recipe_Walkway_T_C",
          "Recipe_Walkway_Turn_C",
          "Recipe_Walkway_Ramp_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_CurvedFoundationPack_C",
    "name": "Quarter Pipes Pack",
    "unlockName": "Quarter Pipes Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 6,
        "displayAmount": 6,
        "originalAmount": 6
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuarterPipe_C",
          "Recipe_QuarterPipe_02_C",
          "Recipe_QuarterPipeCorner_01_C",
          "Recipe_QuarterPipeCorner_02_C",
          "Recipe_QuarterPipeCorner_03_C",
          "Recipe_QuarterPipeCorner_04_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_QuarterPipes_Asphalt_C",
          "CBG_QuarterPipes_Concrete_C",
          "CBG_QuarterPipes_GripMetal_C",
          "CBG_QuarterPipes_Coated_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_QuarterPipes_Asphalt_C",
    "name": "Asphalt Quarter PIpes",
    "unlockName": "Asphalt Quarter PIpes",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Asphalt_FoundationMaterial_C",
      "ResourceSink_CurvedFoundationPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_DownQuarterPipe_Asphalt_8x4_C",
          "Recipe_DownQuarterPipe_AsphaltInCorner_8x4_C",
          "Recipe_DownQuarterPipe_AsphaltOutCorner_8x4_C",
          "Recipe_QuarterPipe_Asphalt_8x4_C",
          "Recipe_QuarterPipeInCorner_Asphalt_8x4_C",
          "Recipe_QuarterPipeOutCorner_Asphalt_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_QuarterPipes_Concrete_C",
    "name": "Concrete Quarter PIpes",
    "unlockName": "Concrete Quarter PIpes",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Concrete_FoundationMaterial_C",
      "ResourceSink_CurvedFoundationPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_DownQuarterPipe_Concrete_8x4_C",
          "Recipe_DownQuarterPipe_ConcreteInCorner_8x4_C",
          "Recipe_DownQuarterPipe_ConcreteOutCorner_8x4_C",
          "Recipe_QuarterPipe_Concrete_8x4_C",
          "Recipe_QuarterPipeInCorner_Concrete_8x4_C",
          "Recipe_QuarterPipeOutCorner_Concrete_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_QuarterPipes_GripMetal_C",
    "name": "Grip Metal Quarter PIpes",
    "unlockName": "Grip Metal Quarter PIpes",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_GripMetal_FoundationMaterial_C",
      "ResourceSink_CurvedFoundationPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_DownQuarterPipe_Grip_8x4_C",
          "Recipe_DownQuarterPipe_GripInCorner_8x4_C",
          "Recipe_DownQuarterPipe_GripOutCorner_8x4_C",
          "Recipe_QuarterPipe_Grip_8x4_C",
          "Recipe_QuarterPipeInCorner_Grip_8x4_C",
          "Recipe_QuarterPipeOutCorner_Grip_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_QuarterPipes_Coated_C",
    "name": "Polished Concrete Quarter PIpes",
    "unlockName": "Polished Concrete Quarter PIpes",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_PolishedConcrete_FoundationMaterial_C",
      "ResourceSink_CurvedFoundationPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_DownQuarterPipe_ConcretePolished_8x4_C",
          "Recipe_DownQuarterPipe_ConcretePolishedInCorner_8x4_C",
          "Recipe_DownQuarterPipe_ConcretePolishedOutCorner_8x4_C",
          "Recipe_QuarterPipe_ConcretePolished_8x4_C",
          "Recipe_QuarterPipeInCorner_ConcretePolished_8x4_C",
          "Recipe_QuarterPipeOutCorner_ConcretePolished_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_CyberWagon_Unlock_C",
    "name": "Cyber Wagon available in the AWESOME Shop",
    "unlockName": "Cyber Wagon available in the AWESOME Shop",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "ResourceSink_FactoryCart_C",
    "name": "FICSIT Factory Cart™",
    "unlockName": "FICSIT Factory Cart™",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_FactoryCart_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_CyberWagon_C",
    "name": "Cyber Wagon",
    "unlockName": "Cyber Wagon",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_CyberWagon_Unlock_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_CyberWagon_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_HalfFoundations_C",
    "name": "Half Foundation Set",
    "unlockName": "Half Foundation Set",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuarterPipeMiddle_Ficsit_4x1_C",
          "Recipe_QuarterPipeMiddle_Ficsit_4x2_C",
          "Recipe_QuarterPipeMiddle_Ficsit_4x4_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Half_Foundations_Asphalt_C",
          "CBG_Half_Foundations_Concrete_C",
          "CBG_Half_Foundations_Metal_C",
          "CBG_Half_Foundations_Polished_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Half_Foundations_Asphalt_C",
    "name": "Asphalt Half Foundations",
    "unlockName": "Asphalt Half Foundations",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_HalfFoundations_C",
      "ResourceSink_Customizer_Asphalt_FoundationMaterial_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuarterPipeMiddle_Asphalt_8x1_C",
          "Recipe_QuarterPipeMiddle_Asphalt_8x2_C",
          "Recipe_QuarterPipeMiddle_Asphalt_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Half_Foundations_Concrete_C",
    "name": "Concrete Half Foundations",
    "unlockName": "Concrete Half Foundations",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_HalfFoundations_C",
      "ResourceSink_Customizer_Concrete_FoundationMaterial_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuarterPipeMiddle_Concrete_8x1_C",
          "Recipe_QuarterPipeMiddle_Concrete_8x2_C",
          "Recipe_QuarterPipeMiddle_Concrete_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Half_Foundations_Metal_C",
    "name": "Grip Metal Half Foundations",
    "unlockName": "Grip Metal Half Foundations",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_HalfFoundations_C",
      "ResourceSink_Customizer_GripMetal_FoundationMaterial_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuarterPipeMiddle_Grip_8x1_C",
          "Recipe_QuarterPipeMiddle_Grip_8x2_C",
          "Recipe_QuarterPipeMiddle_Grip_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Half_Foundations_Polished_C",
    "name": "Polished Concrete Half Foundations",
    "unlockName": "Polished Concrete Half Foundations",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_HalfFoundations_C",
      "ResourceSink_Customizer_PolishedConcrete_FoundationMaterial_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuarterPipeMiddle_PolishedConcrete_8x1_C",
          "Recipe_QuarterPipeMiddle_PolishedConcrete_8x2_C",
          "Recipe_QuarterPipeMiddle_PolishedConcrete_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_QuarterPipeExtensions_C",
    "name": "Quarter Pipe Extensions Pack",
    "unlockName": "Quarter Pipe Extensions Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_QuarterPipeMiddleInCorner_Ficsit_8x1_C",
          "Recipe_QuarterPipeMiddleInCorner_Ficsit_8x2_C",
          "Recipe_QuarterPipeMiddleInCorner_Ficsit_8x4_C",
          "Recipe_QuarterPipeMiddleOutCorner_Ficsit_4x1_C",
          "Recipe_QuarterPipeMiddleOutCorner_Ficsit_4x2_C",
          "Recipe_QuarterPipeMiddleOutCorner_Ficsit_4x4_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_ExtensionQuarterPipes_Asphalt_C",
          "CBG_ExtensionQuarterPipes_Concrete_C",
          "CBG_ExtensionQuarterPipes_GripMetal_C",
          "CBG_ExtensionQuarterPipes_Polished_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_FoundationStairs_C",
    "name": "Foundation Stairs Set",
    "unlockName": "Foundation Stairs Set",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Stair_FicsitSet_8x1_01_C",
          "Recipe_Stair_FicsitSet_8x2_01_C",
          "Recipe_Stair_FicsitSet_8x4_01_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Stairs_Asphalt_C",
          "CBG_Stairs_Coated_C",
          "CBG_Stairs_Concrete_C",
          "CBG_Stairs_Metal_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Stairs_Asphalt_C",
    "name": "Asphalt Stairs",
    "unlockName": "Asphalt Stairs",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Asphalt_FoundationMaterial_C",
      "ResourceSink_FoundationStairs_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Stair_Asphalt_8x1_C",
          "Recipe_Stair_Asphalt_8x2_C",
          "Recipe_Stair_Asphalt_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Stairs_Coated_C",
    "name": "Polished Concrete Stairs",
    "unlockName": "Polished Concrete Stairs",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_PolishedConcrete_FoundationMaterial_C",
      "ResourceSink_FoundationStairs_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Stair_PolishedConcrete_8x1_C",
          "Recipe_Stair_PolishedConcrete_8x2_C",
          "Recipe_Stair_PolishedConcrete_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Stairs_Concrete_C",
    "name": "Concrete Stairs",
    "unlockName": "Concrete Stairs",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Concrete_FoundationMaterial_C",
      "ResourceSink_FoundationStairs_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Stair_Concrete_8x1_C",
          "Recipe_Stair_Concrete_8x2_C",
          "Recipe_Stair_Concrete_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Stairs_Metal_C",
    "name": "Grip Metal Stairs",
    "unlockName": "Grip Metal Stairs",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_GripMetal_FoundationMaterial_C",
      "ResourceSink_FoundationStairs_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Stair_GripMetal_8x1_C",
          "Recipe_Stair_GripMetal_8x2_C",
          "Recipe_Stair_GripMetal_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Ramps_Inverted_Asphalt_C",
    "name": "Asphalt Inverted Ramps",
    "unlockName": "Asphalt Inverted Ramps",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_Asphalt_FoundationMaterial_C",
      "ResourceSink_InvertedRampPack_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_InvertedRamp_Asphalt_8x1_C",
          "Recipe_InvertedRamp_Asphalt_8x2_C",
          "Recipe_InvertedRamp_Asphalt_8x4_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_WindowedWalls_C",
    "name": "Windowed Walls",
    "unlockName": "Windowed Walls",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_1_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 6,
        "displayAmount": 6,
        "originalAmount": 6
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Window_8x4_01_C",
          "Recipe_Wall_Window_8x4_02_C",
          "Recipe_Wall_Window_8x4_03_C",
          "Recipe_Wall_Window_8x4_04_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Concrete_Walls_Windows_C",
          "CBG_Steel_Walls_WIndows_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Concrete_Walls_Windows_C",
    "name": "Windows Concrete Walls",
    "unlockName": "Windows Concrete Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_ConcreteWallMaterial_C",
      "ResourceSink_WindowedWalls_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Concrete_8x4_Window_01_C",
          "Recipe_Wall_Concrete_8x4_Window_02_C",
          "Recipe_Wall_Concrete_8x4_Window_03_C",
          "Recipe_Wall_Concrete_8x4_Window_04_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Steel_Walls_WIndows_C",
    "name": "Windows Steel Walls",
    "unlockName": "Windows Steel Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_SteelWallMaterial_C",
      "ResourceSink_Diagonal_Up_WallSet_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SteelWall_8x4_Window_01_C",
          "Recipe_SteelWall_8x4_Window_02_C",
          "Recipe_SteelWall_8x4_Window_03_C",
          "Recipe_SteelWall_8x4_Window_04_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_GateWalls_C",
    "name": "Gates",
    "unlockName": "Gates",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Gate_8x4_01_C",
          "Recipe_Gate_Automated_8x4_C",
          "Recipe_BigGarageDoor_16x8_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Concrete_Walls_Gates_C",
          "CBG_Steel_Walls_Gates_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Concrete_Walls_Gates_C",
    "name": "Gates Concrete Walls",
    "unlockName": "Gates Concrete Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_ConcreteWallMaterial_C",
      "ResourceSink_GateWalls_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Concrete_Gate_8x4_C",
          "Recipe_BigGarageDoor_16x8_Concrete_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Steel_Walls_Gates_C",
    "name": "Gates Steel Walls",
    "unlockName": "Gates Steel Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_SteelWallMaterial_C",
      "ResourceSink_GateWalls_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SteelWall_8x4_Gate_01_C",
          "Recipe_BigGarageDoor_16x8_Steel_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Tilted_Walls_C",
    "name": "Tilted Walls",
    "unlockName": "Tilted Walls",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Orange_Angular_8x4_C",
          "Recipe_Wall_Orange_Angular_8x8_C",
          "Recipe_Wall_Orange_8x4_Corner_01_C",
          "Recipe_Wall_Orange_8x8_Corner_01_C",
          "Recipe_Wall_Orange_8x4_Corner_02_C",
          "Recipe_Wall_Orange_8x8_Corner_02_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Concrete_Walls_Tilted_C",
          "CBG_Steel_Walls_Tilted_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Concrete_Walls_Tilted_C",
    "name": "Concrete Tilted Walls",
    "unlockName": "Concrete Tilted Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_ConcreteWallMaterial_C",
      "ResourceSink_Tilted_Walls_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Concrete_Angular_8x4_C",
          "Recipe_Wall_Concrete_Angular_8x8_C",
          "Recipe_Wall_Concrete_8x4_Corner_01_C",
          "Recipe_Wall_Concrete_8x8_Corner_01_C",
          "Recipe_Wall_Concrete_8x4_Corner_2_C",
          "Recipe_Wall_Concrete_8x8_Corner_2_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Steel_Walls_Tilted_C",
    "name": "Steel Tilted Walls",
    "unlockName": "Steel Tilted Walls",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_SteelWallMaterial_C",
      "ResourceSink_Tilted_Walls_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_WallSet_Steel_Angular_8x4_C",
          "Recipe_WallSet_Steel_Angular_8x8_C",
          "Recipe_Wall_Steel_8x4_Corner_01_C",
          "Recipe_Wall_Steel_8x8_Corner_01_C",
          "Recipe_Wall_Steel_8x4_Corner_2_C",
          "Recipe_Wall_Steel_8x8_Corner_2_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_ConveryWalls_Normal_C",
    "name": "Conveyor Walls",
    "unlockName": "Conveyor Walls",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Conveyor_8x4_01_C",
          "Recipe_Wall_Conveyor_8x4_02_C",
          "Recipe_Wall_Conveyor_8x4_03_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Concrete_Walls_Conveyor_C",
          "CBG_Steel_Walls_Conveyor_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_ConveyorWallMount_C",
    "name": "Conveyor Wall Mount",
    "unlockName": "Conveyor Wall Mount",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorPoleWall_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_ConveyorCeilingMount_C",
    "name": "Conveyor Ceiling Mount",
    "unlockName": "Conveyor Ceiling Mount",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorCeilingAttachment_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_HyperTubeWallAttachements_C",
    "name": "Hypertube Wall Attachments",
    "unlockName": "Hypertube Wall Attachments",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_4-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_HyperTubeWallSupport_C",
          "Recipe_HyperTubeWallHole_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_PipelineWallAttachments_C",
    "name": "Pipeline Wall Attachments",
    "unlockName": "Pipeline Wall Attachments",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PipeSupportWall_C",
          "Recipe_PipeSupportWallHole_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_PipelineFloorHole_C",
    "name": "Pipeline Floor Hole",
    "unlockName": "Pipeline Floor Hole",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_FoundationPassthrough_Pipe_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_WallPowerPoles_C",
    "name": "Wall Power Outlets Mk.1",
    "unlockName": "Wall Power Outlets Mk.1",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PowerPoleWall_C",
          "Recipe_PowerPoleWallDouble_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_WallPowerPolesMK2_C",
    "name": "Wall Power Outlets Mk.2",
    "unlockName": "Wall Power Outlets Mk.2",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_4_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PowerPoleWallMk2_C",
          "Recipe_PowerPoleWallDoubleMk2_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_WallPowerPolesMK3_C",
    "name": "Wall Power Outlets Mk.3",
    "unlockName": "Wall Power Outlets Mk.3",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_6_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PowerPoleWallMk3_C",
          "Recipe_PowerPoleWallDoubleMk3_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_VentilationBundle_C",
    "name": "Ventilation Bundle",
    "unlockName": "Ventilation Bundle",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_LargeFan_C",
          "Recipe_LargeVent_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_CeilingLight_C",
    "name": "Indoor Lighting",
    "unlockName": "Indoor Lighting",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_2_C",
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_CeilingLight_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_LightTower_C",
    "name": "Flood Lights",
    "unlockName": "Flood Lights",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_2_C",
      "Schematic_4-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_FloodlightPole_C",
          "Recipe_FloodlightWall_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_StreetLight_C",
    "name": "Street Light",
    "unlockName": "Street Light",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_StreetLight_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Statue_Hoggo_C",
    "name": "Silver Hog",
    "unlockName": "Silver Hog",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_StatueLizardDoggo_C",
    "name": "Lizard Doggo",
    "unlockName": "Lizard Doggo",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_StatueSpaceGiraffe_C",
    "name": "Confusing Creature",
    "unlockName": "Confusing Creature",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 200,
        "displayAmount": 200,
        "originalAmount": 200
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_StatueBronzePioneer_C",
    "name": "Adequate Pioneering",
    "unlockName": "Adequate Pioneering",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 25,
        "displayAmount": 25,
        "originalAmount": 25
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_StatueGoldPioneer_C",
    "name": "Satisfactory Pioneering",
    "unlockName": "Satisfactory Pioneering",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 150,
        "displayAmount": 150,
        "originalAmount": 150
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_StatueSilverPioneer_C",
    "name": "Pretty Good Pioneering",
    "unlockName": "Pretty Good Pioneering",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_StatueGoldenNut_C",
    "name": "Golden Nut",
    "unlockName": "Golden Nut",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1000,
        "displayAmount": 1000,
        "originalAmount": 1000
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_StackableShelf_C",
    "name": "Basic Shelf Unit",
    "unlockName": "Basic Shelf Unit",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_StackableShelf_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Customizer_GlassRoofMaterial_C",
    "name": "Glass Roof Material",
    "unlockName": "Glass Roof Material",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Roofs_Basic_C",
      "Research_Quartz_1_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Material_Roof_Glass_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Roofs_Basic_Glass_C",
          "CBG_Roofs_Corners_Glass_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Roofs_Basic_Glass_C",
    "name": "Glass Roofs Basic",
    "unlockName": "Glass Roofs Basic",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_GlassRoofMaterial_C",
      "ResourceSink_Roofs_Basic_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Roof_Window_01_C",
          "Recipe_Roof_Window_02_C",
          "Recipe_Roof_Window_03_C",
          "Recipe_Roof_Window_04_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Roofs_Basic_C",
    "name": "FICSIT Roofs",
    "unlockName": "FICSIT Roofs",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 6,
        "displayAmount": 6,
        "originalAmount": 6
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Roof_Orange_01_C",
          "Recipe_Roof_Orange_02_C",
          "Recipe_Roof_Orange_03_C",
          "Recipe_Roof_Orange_04_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Roofs_Corners_Glass_C",
    "name": "Glass Roof Corners",
    "unlockName": "Glass Roof Corners",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_GlassRoofMaterial_C",
      "ResourceSink_Roofs_Corners_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Roof_Window_InCorner_01_C",
          "Recipe_Roof_Window_InCorner_02_C",
          "Recipe_Roof_Window_InCorner_03_C",
          "Recipe_Roof_Window_OutCorner_01_C",
          "Recipe_Roof_Window_OutCorner_02_C",
          "Recipe_Roof_Window_OutCorner_03_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Roofs_Corners_C",
    "name": "FICSIT Roof Corners",
    "unlockName": "FICSIT Roof Corners",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Roof_Orange_InCorner_01_C",
          "Recipe_Roof_Orange_InCorner_02_C",
          "Recipe_Roof_Orange_InCorner_03_C",
          "Recipe_Roof_Orange_OutCorner_01_C",
          "Recipe_Roof_Orange_OutCorner_02_C",
          "Recipe_Roof_Orange_OutCorner_03_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Roofs_Corners_Glass_C",
          "CBG_Roofs_Corners_Steel_C",
          "CBG_Roofs_Corners_Tar_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Customizer_SteelRoofMaterial_C",
    "name": "Metal Roof Material",
    "unlockName": "Metal Roof Material",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Roofs_Basic_C",
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Material_Roof_Metal_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Roofs_Basic_Steel_C",
          "CBG_Roofs_Corners_Steel_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Roofs_Basic_Steel_C",
    "name": "Metal Roofs Basic",
    "unlockName": "Metal Roofs Basic",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_SteelRoofMaterial_C",
      "ResourceSink_Roofs_Basic_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Roof_A_01_C",
          "Recipe_Roof_A_02_C",
          "Recipe_Roof_A_03_C",
          "Recipe_Roof_A_04_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Roofs_Corners_Steel_C",
    "name": "Metal Roof Corners",
    "unlockName": "Metal Roof Corners",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_SteelRoofMaterial_C",
      "ResourceSink_Roofs_Corners_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Roof_Metal_InCorner_01_C",
          "Recipe_Roof_Metal_InCorner_02_C",
          "Recipe_Roof_Metal_InCorner_03_C",
          "Recipe_Roof_Metal_OutCorner_01_C",
          "Recipe_Roof_Metal_OutCorner_02_C",
          "Recipe_Roof_Metal_OutCorner_03_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Customizer_TarRoofMaterial_C",
    "name": "Tar Roof Material",
    "unlockName": "Tar Roof Material",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Roofs_Basic_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Material_Roof_Tar_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Roofs_Basic_Tar_C",
          "CBG_Roofs_Corners_Tar_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Roofs_Basic_Tar_C",
    "name": "Tar Roofs Basic",
    "unlockName": "Tar Roofs Basic",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_TarRoofMaterial_C",
      "ResourceSink_Roofs_Basic_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Roof_Tar_01_C",
          "Recipe_Roof_Tar_02_C",
          "Recipe_Roof_Tar_03_C",
          "Recipe_Roof_Tar_04_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_Roofs_Corners_Tar_C",
    "name": "Tar Roof Corners",
    "unlockName": "Tar Roof Corners",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_Customizer_TarRoofMaterial_C",
      "ResourceSink_Roofs_Corners_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Roof_Tar_InCorner_01_C",
          "Recipe_Roof_Tar_InCorner_02_C",
          "Recipe_Roof_Tar_InCorner_03_C",
          "Recipe_Roof_Tar_OutCorner_01_C",
          "Recipe_Roof_Tar_OutCorner_02_C",
          "Recipe_Roof_Tar_OutCorner_03_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_PersonnelElevator_C",
    "name": "Personnel Elevator",
    "unlockName": "Personnel Elevator",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_1_2_C",
      "Schematic_4-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Elevator_C",
          "Recipe_ElevatorFloorStop_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_NoIndicator_PipelineMK2_C",
    "name": "Clean Pipeline Mk.2",
    "unlockName": "Clean Pipeline Mk.2",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_6-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PipelineMK2_NoIndicator_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_NoIndicator_PipelineMK1_C",
    "name": "Clean Pipeline Mk.1",
    "unlockName": "Clean Pipeline Mk.1",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Pipeline_NoIndicator_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_MedicalBoxSkin_C",
    "name": "Medical Box - Personal Storage Skin",
    "unlockName": "Medical Box - Personal Storage Skin",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_StorageMedkit_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_LightControlPanel_C",
    "name": "Light Control Panel",
    "unlockName": "Light Control Panel",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_LightsControlPanel_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_LabelSigns_C",
    "name": "Label Sign Bundle",
    "unlockName": "Label Sign Bundle",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_1_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_StandaloneWidgetSign_Small_C",
          "Recipe_StandaloneWidgetSign_SmallWide_C",
          "Recipe_StandaloneWidgetSign_SmallVeryWide_C",
          "Recipe_StandaloneWidgetSign_Square_Tiny_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_HyperTubeFloorHole_C",
    "name": "Hypertube Floor Hole",
    "unlockName": "Hypertube Floor Hole",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_4-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_FoundationPassthrough_Hypertube_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_HazardBoxSkin_C",
    "name": "Hazard Box - Personal Storage Skin",
    "unlockName": "Hazard Box - Personal Storage Skin",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_StorageHazard_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_GoldenCup_C",
    "name": "'Employee of the Planet' Cup",
    "unlockName": "'Employee of the Planet' Cup",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_GoldenCart_Unlock_C",
    "name": "Golden Cart available in the AWESOME Shop",
    "unlockName": "Golden Cart available in the AWESOME Shop",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "ResourceSink_GoldenCart_C",
    "name": "Golden FICSIT Factory Cart™",
    "unlockName": "Golden FICSIT Factory Cart™",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_GoldenCart_Unlock_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_GoldenCart_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_FrameWindows_C",
    "name": "Steel-Framed Windows",
    "unlockName": "Steel-Framed Windows",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_1_2_C",
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 6,
        "displayAmount": 6,
        "originalAmount": 6
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Wall_Window_Thin_8x4_01_C",
          "Recipe_Wall_Window_Thin_8x4_02_C",
          "Recipe_Wall_Window_8x4_06_C",
          "Recipe_Wall_Window_8x4_07_C",
          "Recipe_Wall_Window_8x4_05_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_FramePillarSet_C",
    "name": "Frame Pillar Set",
    "unlockName": "Frame Pillar Set",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PillarMiddle_Frame_C",
          "Recipe_PillarBase_C",
          "Recipe_Pillar_Small_Frame_C",
          "Recipe_PillarBase_Small_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Fences_C",
    "name": "Construction Fences",
    "unlockName": "Construction Fences",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_TarpFence_C",
          "Recipe_ChainLinkFence_C"
        ]
      },
      {
        "type": "Schematic",
        "scripts": [
          "CBG_Concrete_Walls_Tilted_C",
          "CBG_Steel_Walls_Tilted_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_FactoryBarrier2_C",
    "name": "Metal Barriers",
    "unlockName": "Metal Barriers",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Barrier_Low_01_C",
          "Recipe_Barrier_Tall_01_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_FactoryBarrier_C",
    "name": "Road Barriers",
    "unlockName": "Road Barriers",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Concrete_Barrier_01_C",
          "Recipe_Barrier_Corner_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_DisplaySigns_C",
    "name": "Display Sign Bundle",
    "unlockName": "Display Sign Bundle",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_1_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_StandaloneWidgetSign_Medium_C",
          "Recipe_StandaloneWidgetSign_Portrait_C",
          "Recipe_StandaloneWidgetSign_Square_Small_C",
          "Recipe_StandaloneWidgetSign_Square_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_ConveyorWallHole_C",
    "name": "Conveyor Wall Hole",
    "unlockName": "Conveyor Wall Hole",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorWallHole_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_ConveyorMonitor_C",
    "name": "Conveyor Throughput Monitor",
    "unlockName": "Conveyor Throughput Monitor",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorMonitor_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_ConveyorLiftHole_C",
    "name": "Conveyor Lift Floor Hole",
    "unlockName": "Conveyor Lift Floor Hole",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_FoundationPassthrough_Lift_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_ConcretePillarSet_C",
    "name": "Concrete Pillar Set",
    "unlockName": "Concrete Pillar Set",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PillarMiddle_Concrete_C",
          "Recipe_PillarBase_C",
          "Recipe_Pillar_Small_Concrete_C",
          "Recipe_PillarBase_Small_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Checkmark_C",
    "name": "FICSIT Checkmark™",
    "unlockName": "FICSIT Checkmark™",
    "description": "The FICSIT Checkmark™ is a way for pioneers to truly distinguish themselves as Verified pioneers. It's an opt-in, paid subscription that adds an orange checkmark to your player ID in online sessions and offers no other beneficial features. \r\n\r\nThe goal of the FICSIT Checkmark™ is to increase trust in FICSIT Inc. by providing a visual signifier that notable pioneers are the real deal and not just impostors or parody pioneers that can’t afford the Coupons.  \r\n\r\nThe FICSIT Checkmark™ will only be visible in online sessions for other pioneers to witness your certification status within FICSIT. The knowledge of purchase is its own reward.",
    "tier": null,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "ResourceSink_CyberWagon_Unlock_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 8,
        "displayAmount": 8,
        "originalAmount": 8
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Catwalks_C",
    "name": "Modern Catwalks",
    "unlockName": "Modern Catwalks",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Catwalk_Straight_C",
          "Recipe_Catwalk_Cross_C",
          "Recipe_Catwalk_T_C",
          "Recipe_Catwalk_Turn_C",
          "Recipe_Catwalk_Ramp_C",
          "Recipe_Catwalk_Stairs_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Boombox_C",
    "name": "Boombox",
    "unlockName": "Boombox",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_BillboardSigns_C",
    "name": "Billboard Set",
    "unlockName": "Billboard Set",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_1_1_C",
      "Schematic_4-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_StandaloneWidgetSign_Large_C",
          "Recipe_StandaloneWidgetSign_Huge_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_BeamSet_Cables_C",
    "name": "Structural Cable Pack",
    "unlockName": "Structural Cable Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Beam_Cable_C",
          "Recipe_Beam_Cable_Cluster_C",
          "Recipe_Beam_Support_C",
          "Recipe_Beam_Connector_C",
          "Recipe_Beam_Connector_Double_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_BeamSet2_C",
    "name": "Beam Expansion Pack",
    "unlockName": "Beam Expansion Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Beam_Concrete_C",
          "Recipe_Beam_H_C",
          "Recipe_Beam_Shelf_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_BeamSet_C",
    "name": "Structural Beam Pack",
    "unlockName": "Structural Beam Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Beam_C",
          "Recipe_Beam_Painted_C",
          "Recipe_Beam_Support_C",
          "Recipe_Beam_Connector_C",
          "Recipe_Beam_Connector_Double_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Purchasable_HardDrive_C",
    "name": "Hard Drive",
    "unlockName": "Hard Drive",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_RifleAmmoTurbo_C",
    "name": "Turbo Rifle Ammo Pack",
    "unlockName": "Turbo Rifle Ammo Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_5_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_RifleAmmoHoming_C",
    "name": "Homing Rifle Ammo Pack",
    "unlockName": "Homing Rifle Ammo Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_6_3_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_RebarStun_C",
    "name": "Stun Rebar Pack",
    "unlockName": "Stun Rebar Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_3_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_RebarShatter_C",
    "name": "Shatter Rebar Pack",
    "unlockName": "Shatter Rebar Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_2_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_RebarExplosive_C",
    "name": "Explosive Rebar Pack",
    "unlockName": "Explosive Rebar Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_4_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_RadiationFilters_C",
    "name": "Radiation Filters",
    "unlockName": "Radiation Filters",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-3_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_NobeliskPulse_C",
    "name": "Pulse Nobelisk Pack",
    "unlockName": "Pulse Nobelisk Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_3_4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_NobeliskGas_C",
    "name": "Gas Nobelisk Pack",
    "unlockName": "Gas Nobelisk Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Mycelia_8_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_NobeliskCluster_C",
    "name": "Cluster Nobelisk Pack",
    "unlockName": "Cluster Nobelisk Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_HealthPack_C",
    "name": "Health Pack",
    "unlockName": "Health Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_AOrgans_2_C",
      "Research_Nutrients_4_C",
      "Research_Mycelia_5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_GasFilters_C",
    "name": "Gas Filters",
    "unlockName": "Gas Filters",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_6-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Explosives_C",
    "name": "Nobelisk Pack",
    "unlockName": "Nobelisk Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_3_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_CoffeeCup_C",
    "name": "FICSIT™ Coffee Cup",
    "unlockName": "FICSIT™ Coffee Cup",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_AmmoPack_C",
    "name": "Iron Rebar Pack",
    "unlockName": "Iron Rebar Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_ACarapace_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_AdvancedAmmoPack_C",
    "name": "Rifle Ammo Pack",
    "unlockName": "Rifle Ammo Pack",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_4_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Wire_C",
    "name": "Wire",
    "unlockName": "Wire",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Screw_C",
    "name": "Screws",
    "unlockName": "Screws",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Rod_C",
    "name": "Iron Rod",
    "unlockName": "Iron Rod",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_QuartzCrystal_C",
    "name": "Quartz Crystal",
    "unlockName": "Quartz Crystal",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_1_1_C",
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Plate_C",
    "name": "Iron Plate",
    "unlockName": "Iron Plate",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Concrete_C",
    "name": "Concrete",
    "unlockName": "Concrete",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Cable_C",
    "name": "Cable",
    "unlockName": "Cable",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Biomass_C",
    "name": "Biomass",
    "unlockName": "Biomass",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Rotor_C",
    "name": "Rotor",
    "unlockName": "Rotor",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_2-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_ReinforcedIronPlate_C",
    "name": "Reinforced Iron Plate",
    "unlockName": "Reinforced Iron Plate",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Quickwire_C",
    "name": "Quickwire",
    "unlockName": "Quickwire",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_ModularFrame_C",
    "name": "Modular Frame",
    "unlockName": "Modular Frame",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_2-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Fabric_C",
    "name": "Fabric",
    "unlockName": "Fabric",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Mycelia_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_CopperSheet_C",
    "name": "Copper Sheet",
    "unlockName": "Copper Sheet",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_2-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Biofuel_C",
    "name": "Biofuel",
    "unlockName": "Biofuel",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_2-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_AILimiter_C",
    "name": "AI Limiter",
    "unlockName": "AI Limiter",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_4_1_C",
      "Schematic_7-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_SteelPipe_C",
    "name": "Steel Pipe",
    "unlockName": "Steel Pipe",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_SteelBeam_C",
    "name": "Steel Beam",
    "unlockName": "Steel Beam",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_BlackPowder_C",
    "name": "Black Powder",
    "unlockName": "Black Powder",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Stator_C",
    "name": "Stator",
    "unlockName": "Stator",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_4-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_EncasedIndustrialBeam_C",
    "name": "Encased Industrial Beam",
    "unlockName": "Encased Industrial Beam",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_4-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_CompactedCoal_C",
    "name": "Compacted Coal",
    "unlockName": "Compacted Coal",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_CompactedCoal_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_SmokelessPowder_C",
    "name": "Smokeless Powder",
    "unlockName": "Smokeless Powder",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_3_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Rubber_C",
    "name": "Rubber",
    "unlockName": "Rubber",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Plastic_C",
    "name": "Plastic",
    "unlockName": "Plastic",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_PetroleumCoke_C",
    "name": "Petroleum Coke",
    "unlockName": "Petroleum Coke",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Motor_C",
    "name": "Motor",
    "unlockName": "Motor",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_4-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_HighSpeedConnector_C",
    "name": "High-Speed Connector",
    "unlockName": "High-Speed Connector",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_5_C",
      "Schematic_7-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_EmptyCanister_C",
    "name": "Empty Canister",
    "unlockName": "Empty Canister",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_CrystalOscillator_C",
    "name": "Crystal Oscillator",
    "unlockName": "Crystal Oscillator",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_2_C",
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_CircuitBoard_C",
    "name": "Circuit Board",
    "unlockName": "Circuit Board",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_PolymerResin_C",
    "name": "Polymer Resin",
    "unlockName": "Polymer Resin",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_PackagedTurboFuel_C",
    "name": "Packaged Turbofuel",
    "unlockName": "Packaged Turbofuel",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_TurboFuel_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_PackagedFuel_C",
    "name": "Packaged Fuel",
    "unlockName": "Packaged Fuel",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_PackagedBiofuel_C",
    "name": "Packaged Liquid Biofuel",
    "unlockName": "Packaged Liquid Biofuel",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_HeavyModularFrame_C",
    "name": "Heavy Modular Frame",
    "unlockName": "Heavy Modular Frame",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 6,
        "displayAmount": 6,
        "originalAmount": 6
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Computer_C",
    "name": "Computer",
    "unlockName": "Computer",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_5-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 6,
        "displayAmount": 6,
        "originalAmount": 6
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_TurboMotor_C",
    "name": "Turbo Motor",
    "unlockName": "Turbo Motor",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 8,
        "displayAmount": 8,
        "originalAmount": 8
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_SuperComputer_C",
    "name": "Supercomputer",
    "unlockName": "Supercomputer",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_6_1_C",
      "Schematic_7-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 8,
        "displayAmount": 8,
        "originalAmount": 8
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Silica_C",
    "name": "Silica",
    "unlockName": "Silica",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Quartz_1_2_C",
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_RadioControlUnit_C",
    "name": "Radio Control Unit",
    "unlockName": "Radio Control Unit",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 7,
        "displayAmount": 7,
        "originalAmount": 7
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_HeatSink_C",
    "name": "Heat Sink",
    "unlockName": "Heat Sink",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Battery_C",
    "name": "Battery",
    "unlockName": "Battery",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_AluminumCasing_C",
    "name": "Aluminum Casing",
    "unlockName": "Aluminum Casing",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_AlcladSheet_C",
    "name": "Alclad Aluminum Sheet",
    "unlockName": "Alclad Aluminum Sheet",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_7-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_PressureConversionCube_C",
    "name": "Pressure Conversion Cube",
    "unlockName": "Pressure Conversion Cube",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 8,
        "displayAmount": 8,
        "originalAmount": 8
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_FusedModularFrame_C",
    "name": "Fused Modular Frame",
    "unlockName": "Fused Modular Frame",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 7,
        "displayAmount": 7,
        "originalAmount": 7
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_EmptyFluidTank_C",
    "name": "Empty Fluid Tank",
    "unlockName": "Empty Fluid Tank",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_ElectromagneticControlRod_C",
    "name": "Electromagnetic Control Rod",
    "unlockName": "Electromagnetic Control Rod",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_CopperPowder_C",
    "name": "Copper Powder",
    "unlockName": "Copper Powder",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_CoolingSystem_C",
    "name": "Cooling System",
    "unlockName": "Cooling System",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_8-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_TimeCrystal_C",
    "name": "Time Crystal",
    "unlockName": "Time Crystal",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_SyntheticPowerShard_C",
    "name": "Synthetic Power Shard",
    "unlockName": "Synthetic Power Shard",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_PowerSlugs_6_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_SuperPositionOscillator_C",
    "name": "Superposition Oscillator",
    "unlockName": "Superposition Oscillator",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 9,
        "displayAmount": 9,
        "originalAmount": 9
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_RocketFuel_C",
    "name": "Packaged Rocket Fuel",
    "unlockName": "Packaged Rocket Fuel",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_RocketFuel_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 6,
        "displayAmount": 6,
        "originalAmount": 6
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_NeuralQuantumProcessor_C",
    "name": "Neural-Quantum Processor",
    "unlockName": "Neural-Quantum Processor",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_IonizedFuel_C",
    "name": "Packaged Ionized Fuel",
    "unlockName": "Packaged Ionized Fuel",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Sulfur_IonizedFuel_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 8,
        "displayAmount": 8,
        "originalAmount": 8
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_FicsiteTrigon_C",
    "name": "Ficsite Trigon",
    "unlockName": "Ficsite Trigon",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_9-1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": []
  },
  {
    "id": "ResourceSink_Zones_FoundationPatterns_C",
    "name": "Factory Zone Patterns",
    "unlockName": "Factory Zone Patterns",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Pattern_ZoneFull_C",
          "Recipe_Pattern_ZoneHalf_C",
          "Recipe_Pattern_ZoneQuarter_C",
          "Recipe_Pattern_ZoneLine_C",
          "Recipe_Pattern_Remover_Zones_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_UnPainted_PaintFinish_C",
    "name": "Unpainted Finish",
    "unlockName": "Unpainted Finish",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PaintFinish_UnPainted_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Pathways_FoundationPatterns_C",
    "name": "Pathway Patterns",
    "unlockName": "Pathway Patterns",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 6,
        "displayAmount": 6,
        "originalAmount": 6
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Pattern_PathStraight_C",
          "Recipe_Pattern_PathCorner_C",
          "Recipe_Pattern_PathSplit_C",
          "Recipe_Pattern_PathCross_C",
          "Recipe_Pattern_PathPioneer_C",
          "Recipe_Pattern_PathCart_C",
          "Recipe_Pattern_PathZebra_C",
          "Recipe_Pattern_Remover_Paths_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Number_FoundationPatterns_C",
    "name": "Number Patterns",
    "unlockName": "Number Patterns",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 2,
        "displayAmount": 2,
        "originalAmount": 2
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Pattern_Number0_C",
          "Recipe_Pattern_Number1_C",
          "Recipe_Pattern_Number2_C",
          "Recipe_Pattern_Number3_C",
          "Recipe_Pattern_Number4_C",
          "Recipe_Pattern_Number5_C",
          "Recipe_Pattern_Number6_C",
          "Recipe_Pattern_Number7_C",
          "Recipe_Pattern_Number8_C",
          "Recipe_Pattern_Number9_C",
          "Recipe_Pattern_Remover_Numbers_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_IconsTransport_FoundationPatterns_C",
    "name": "Transportation Icon Patterns",
    "unlockName": "Transportation Icon Patterns",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Pattern_Icon_Tractor_C",
          "Recipe_Pattern_Icon_Truck_C",
          "Recipe_Pattern_Icon_Explorer_C",
          "Recipe_Pattern_Icon_Cart_C",
          "Recipe_Pattern_NO_Cart_C",
          "Recipe_Pattern_Icon_Parking_C",
          "Recipe_Pattern_NO_Parking_C",
          "Recipe_Pattern_FullZebra_C",
          "Recipe_Pattern_Remover_Icons_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_IconsFactory_FoundationPatterns_C",
    "name": "Factory Icon Patterns",
    "unlockName": "Factory Icon Patterns",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 3,
        "displayAmount": 3,
        "originalAmount": 3
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Pattern_Icon_Factory_C",
          "Recipe_Pattern_Icon_Power_C",
          "Recipe_Pattern_Icon_Storage_C",
          "Recipe_Pattern_Icon_Nuclear_C",
          "Recipe_Pattern_Icon_Liquid_C",
          "Recipe_Pattern_Icon_StopCross_C",
          "Recipe_Pattern_Icon_Pioneer_C",
          "Recipe_Pattern_NO_Pioneer_C",
          "Recipe_Pattern_Remover_Icons_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_FullLines_FoundationPatterns_C",
    "name": "Solid Line Patterns",
    "unlockName": "Solid Line Patterns",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Pattern_LineCentre_C",
          "Recipe_Pattern_LineCentreCorner_C",
          "Recipe_Pattern_LineSplit_C",
          "Recipe_Pattern_LineCross_C",
          "Recipe_Pattern_LineSide_C",
          "Recipe_Pattern_LineSideCorner_C",
          "Recipe_Pattern_LineDouble_C",
          "Recipe_Pattern_Remover_Lines_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_DotLines_FoundationPatterns_C",
    "name": "Dotted Line Patterns",
    "unlockName": "Dotted Line Patterns",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 4,
        "displayAmount": 4,
        "originalAmount": 4
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Pattern_DottedCentre_C",
          "Recipe_Pattern_DottedCentreCorner_C",
          "Recipe_Pattern_DottedSplit_C",
          "Recipe_Pattern_DottedCross_C",
          "Recipe_Pattern_DottedSide_C",
          "Recipe_Pattern_DottedSideCorner_C",
          "Recipe_Pattern_DottedDouble_C",
          "Recipe_Pattern_Remover_Lines_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Copper_PaintFinish_C",
    "name": "Copper Paint Finish",
    "unlockName": "Copper Paint Finish",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PaintFinish_Copper_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Chrome_PaintFinish_C",
    "name": "Chrome Paint Finish",
    "unlockName": "Chrome Paint Finish",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 5,
        "displayAmount": 5,
        "originalAmount": 5
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PaintFinish_Chrome_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Caterium_PaintFinish_C",
    "name": "Caterium Paint Finish",
    "unlockName": "Caterium Paint Finish",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Research_Caterium_2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PaintFinish_Caterium_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_CarbonSteel_PaintFinish_C",
    "name": "Carbon Steel Finish",
    "unlockName": "Carbon Steel Finish",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [
      "Schematic_3-4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 8,
        "displayAmount": 8,
        "originalAmount": 8
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_PaintFinish_CarbonSteel_C"
        ]
      }
    ]
  },
  {
    "id": "ResourceSink_Arrows_FoundationPatterns_C",
    "name": "Arrow Patterns",
    "unlockName": "Arrow Patterns",
    "description": "",
    "tier": 1,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Pattern_ArrowStraight_C",
          "Recipe_Pattern_ArrowLeft_C",
          "Recipe_Pattern_ArrowRight_C",
          "Recipe_Pattern_ArrowBack_C",
          "Recipe_Pattern_NO_ArrowStraight_C",
          "Recipe_Pattern_NO_ArrowLeft_C",
          "Recipe_Pattern_NO_ArrowRight_C",
          "Recipe_Pattern_Remover_Arrows_C"
        ]
      }
    ]
  },
  {
    "id": "CBG_PatternRemoval_C",
    "name": "Pattern Removal",
    "unlockName": "Pattern Removal",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Pattern_Remover_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_SongsOfConquest_C",
    "name": "Songs of Conquest Boombox Tape",
    "unlockName": "Songs of Conquest Boombox Tape",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Sanctum2_C",
    "name": "Sanctum 2 Boombox Tape",
    "unlockName": "Sanctum 2 Boombox Tape",
    "description": "",
    "tier": null,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Schematic_Sanctum_C",
    "name": "Sanctum Boombox Tape",
    "unlockName": "Sanctum Boombox Tape",
    "description": "",
    "tier": null,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Schematic_LeMichael_C",
    "name": "Le Michael Boombox Tape",
    "unlockName": "Le Michael Boombox Tape",
    "description": "",
    "tier": null,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Schematic_JoelSyntholm_C",
    "name": "Joel Syntholm Boombox Tape",
    "unlockName": "Joel Syntholm Boombox Tape",
    "description": "",
    "tier": null,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Schematic_Huntdown_C",
    "name": "Huntdown Boombox Tape",
    "unlockName": "Huntdown Boombox Tape",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Goat_C",
    "name": "Goat Music Boombox Tape",
    "unlockName": "Goat Music Boombox Tape",
    "description": "",
    "tier": null,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_FicsmasHits_C",
    "name": "FICSMAS Greatest Hits",
    "unlockName": "FICSMAS Greatest Hits",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_Ficsday2025_C",
    "name": "FICSIT Anniversary Boombox Tape",
    "unlockName": "FICSIT Anniversary Boombox Tape",
    "description": "",
    "tier": null,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Schematic_DeepRockGalactic_C",
    "name": "Deep Rock Galactic Boombox Tape",
    "unlockName": "Deep Rock Galactic Boombox Tape",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Schematic_AbsoluteFicsit_C",
    "name": "Absolute FICSIT Boombox Tape",
    "unlockName": "Absolute FICSIT Boombox Tape",
    "description": "",
    "tier": null,
    "type": "ResourceSink",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_ResourceSinkCoupon_C",
        "amount": 1,
        "displayAmount": 1,
        "originalAmount": 1
      }
    ],
    "unlocks": []
  },
  {
    "id": "Schematic_Tutorial1_C",
    "name": "HUB Upgrade 1",
    "unlockName": "HUB Upgrade 1",
    "description": "",
    "tier": null,
    "type": "Tutorial",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronRod_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Workshop_C",
          "Recipe_PortableMiner_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Tutorial1_5_C",
    "name": "HUB Upgrade 2",
    "unlockName": "HUB Upgrade 2",
    "description": "",
    "tier": null,
    "type": "Tutorial",
    "imagePath": null,
    "dependencies": [
      "Schematic_Tutorial1_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronRod_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SmelterBasicMk1_C",
          "Recipe_PowerLine_C",
          "Recipe_IngotCopper_C",
          "Recipe_Wire_C",
          "Recipe_Cable_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Tutorial2_C",
    "name": "HUB Upgrade 3",
    "unlockName": "HUB Upgrade 3",
    "description": "",
    "tier": null,
    "type": "Tutorial",
    "imagePath": null,
    "dependencies": [
      "Schematic_Tutorial1_5_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronPlate_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      },
      {
        "resource": "Desc_IronRod_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConstructorMk1_C",
          "Recipe_PowerPoleMk1_C",
          "Recipe_Concrete_C",
          "Recipe_Screw_C",
          "Recipe_IronPlateReinforced_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Tutorial3_C",
    "name": "HUB Upgrade 4",
    "unlockName": "HUB Upgrade 4",
    "description": "",
    "tier": null,
    "type": "Tutorial",
    "imagePath": null,
    "dependencies": [
      "Schematic_Tutorial2_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronPlate_C",
        "amount": 75,
        "displayAmount": 75,
        "originalAmount": 75
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      },
      {
        "resource": "Desc_Cement_C",
        "amount": 10,
        "displayAmount": 10,
        "originalAmount": 10
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_ConveyorPole_C",
          "Recipe_ConveyorBeltMk1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Tutorial4_C",
    "name": "HUB Upgrade 5",
    "unlockName": "HUB Upgrade 5",
    "description": "",
    "tier": null,
    "type": "Tutorial",
    "imagePath": null,
    "dependencies": [
      "Schematic_Tutorial3_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronRod_C",
        "amount": 75,
        "displayAmount": 75,
        "originalAmount": 75
      },
      {
        "resource": "Desc_Cable_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      },
      {
        "resource": "Desc_Cement_C",
        "amount": 20,
        "displayAmount": 20,
        "originalAmount": 20
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_MinerMk1_C",
          "Recipe_StorageContainerMk1_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_Tutorial5_C",
    "name": "HUB Upgrade 6",
    "unlockName": "HUB Upgrade 6",
    "description": "",
    "tier": null,
    "type": "Tutorial",
    "imagePath": null,
    "dependencies": [
      "Schematic_Tutorial4_C"
    ],
    "hiddenUntilDependeciesMet": false,
    "cost": [
      {
        "resource": "Desc_IronRod_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_IronPlate_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Wire_C",
        "amount": 100,
        "displayAmount": 100,
        "originalAmount": 100
      },
      {
        "resource": "Desc_Cement_C",
        "amount": 50,
        "displayAmount": 50,
        "originalAmount": 50
      }
    ],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SpaceElevator_C",
          "Recipe_Biomass_Wood_C",
          "Recipe_Biomass_Leaves_C",
          "Recipe_GeneratorBiomass_Automated_C"
        ]
      }
    ]
  },
  {
    "id": "Schematic_XMassTree_C",
    "name": "",
    "unlockName": "",
    "description": "",
    "tier": null,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  },
  {
    "id": "Ficsmas_Schematic_SkinBundle_2_C",
    "name": "Premium FICSMAS Skins",
    "unlockName": "Premium FICSMAS Skins",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SkinFicsmas_Premium_C",
          "Recipe_SkinRemover_C"
        ]
      }
    ]
  },
  {
    "id": "Ficsmas_Schematic_SkinBundle_1_C",
    "name": "Basic FICSMAS Skins",
    "unlockName": "Basic FICSMAS Skins",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_SkinFicsmas_Default_C",
          "Recipe_SkinRemover_C"
        ]
      }
    ]
  },
  {
    "id": "Ficsmas_Schematic_Fireworks_C",
    "name": "Equipment: Fireworks",
    "unlockName": "Equipment: Fireworks",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": [
      {
        "type": "Recipe",
        "scripts": [
          "Recipe_Fireworks_01_C",
          "Recipe_Fireworks_02_C",
          "Recipe_Fireworks_03_C"
        ]
      }
    ]
  },
  {
    "id": "Ficsmas_Schematic_FingerGun_Emote_C",
    "name": "Emote: Finger Guns!",
    "unlockName": "Emote: Finger Guns!",
    "description": "",
    "tier": 1,
    "type": "Custom",
    "imagePath": null,
    "dependencies": [],
    "hiddenUntilDependeciesMet": false,
    "cost": [],
    "unlocks": []
  }
]